import React from 'react';
import SideBar from '../Sidebar';
import "./style.css"
import Footer from '../Footer/Footer';
import { Button, TablePagination } from '@material-ui/core';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Box, IconButton, ButtonGroup, Menu, MenuItem, Autocomplete, TextField } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { withRouter } from 'react-router-dom';
import API from '../../Api';
// React Notification
import { NotificationManager } from 'react-notifications';
import 'reactjs-crontab/dist/index.css';
import { columnHeader, columnHeader2 } from './data';
import moment from 'moment';
import { searchItems, claimsDropdown } from '../Footer/data';
import _, { values } from 'lodash';
import Loader from 'react-loader-spinner';
import PropTypes from 'prop-types';
import refresh from '../../assets/icons/Refresh.svg';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import ruleoutLogo from '../../assets/icons/logo2.svg';
import { LoadingSpinner } from 'lib/loader';
import { getDataFromSession } from '../helper/helper'
import { RoCheckbox } from 'layouts/Form/Checkbox';
import openInNew from '../../assets/icons/openInNew.svg';
import exportIcon from '../../assets/icons/export.svg';
import XLSX from "xlsx-js-style";
import { formatPhoneNumber } from "components/helper/helper";
// import jwt_decode from 'jwt-decode';
// import io from "socket.io-client";
import { socketInstance, getClientKey } from '../../socket/connection';
import ClaimNoteHistory from './noteHistory';

let socket = socketInstance();

const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy HH:MM');

let myCurrentDate = new Date();
let myPastDate = new Date(myCurrentDate);
myPastDate.setDate(myPastDate.getDate() - 60);
let maxPastDate = new Date(myCurrentDate);
maxPastDate.setDate(maxPastDate.getDate() - 365)

let currentToDate = new Date(Date.now());

let rulesTimer;
let client
let user
// let client = JSON.parse(sessionStorage.getItem("clientDetail"));
// let user = JSON.parse(sessionStorage.getItem("userDetail"));
// console.log(user?.roleId)

class RuleProcessor extends React.Component {
    autoRefresh;
    // new addition for Exteral User
    practiceWaitTimer = null;
    constructor(props) {
        super(props);
        this.autoCAssignRef = React.createRef();
        this.assigntoHint = "";
        const eachPageContaiRow = 100;
        this.reviewedPaginationOptions = [100, 250, 500, 1000];
        this.notRanPaginationOptions = [100];
        const initialClaimsDropdownSelect = (user?.roleId == 9 || this.props.history?.location?.state?.claimsDropdownSelect) ? 'claimsNotReviewed' : 'notRan';
        this.SESSION_PRACTICE_KEY = 'practice'
        this.state = {
            refreshPractice: () => { },
            customSetPractice: () => { },
            encounters: [],
            encountersCopy: [],
            encounterData: [],
            newEncounters: [],
            selectedValues: [],
            showRule: false,
            isLoading: false,
            getLastRule: [],
            chargeData: [],
            date: null,
            localDate: null,
            rulesRan: false,
            trizettoData: [],
            eligibilityData: [],
            ruleDate: null,
            formattedRuleDate: null,
            rulesData: [],
            rulesDataCopy: [],
            sortData: false,
            showPopup: false,
            showCancelPopup: false,
            showRulesTryAgain: false,
            showChargesPopup: false,
            showRunningCharges: false,
            showCancelRunningCharges: false,
            showChargesTryAgain: false,
            showLoader: false,
            showCancelLoader: false,
            selectDateType: 'createdDate',
            fromDate: null,
            toDate: null,
            fromDate1: null,
            toDate1: null,
            filterDateType: '',
            selectedColumn: null,
            encounterCount: 0,

            checkboxError: '',

            checkedItems: {},
            count: 0,
            message: null,
            ruleSuccess: '',
            searchKey: '',
            searchValue: '',
            searchData: '',
            trizettoSuccess: false,
            practiceId: '',
            practiceId1: JSON.parse(sessionStorage.getItem('practice'))?.id,
            pmLinkedStatus: JSON.parse(sessionStorage.getItem('practice'))?.PMLinkedStatus,
            optionSelector: false,
            // draftPlaceholder: '',
            encounterLength: null,
            claimSelector: false,
            labelValue: '',
            claimKey: '',
            autoRunRuleChecked: false,
            claimsDropdownSelect: initialClaimsDropdownSelect,
            totalRows: 0,
            page: 0,
            offset: 0,
            sortKey: '',
            sortDirection: 'asc',
            pages: initialClaimsDropdownSelect === 'notRan' ? this.notRanPaginationOptions : this.reviewedPaginationOptions,
            rowsPerPage: eachPageContaiRow,
            enableAutoRunRuleSetting: false,
            count_encounters: 0,
            filter_count: 0,
            providerType: '',
            showProviderPopUp: false,
            handlePracticeChangeByNotReviewPage: () => { },
            tabValue: 0,
            selectedColumnData: [],
            selectedColumnDataCopy: [],
            filterKey: '',
            checkboxValues: [],
            showSearch: false,
            showCheckedValues: false,
            filteredValues: [],
            searchName: '',
            filterData: {
                EncounterID: [],
                ServiceLocationName: [],
                ProcedureCode: [],
                ServiceStartDate: [],
                SchedulingProviderName: [],
                PrimaryInsurancePlanName: [],
                EncounterDiagnosisID1: [],
                PatientName: []
            },
            goBackCheckbox: '',
            apiLoading: false,
            isFilter: false,
            filterClaims: null,
            totalFilteredRecords: null,
            isCalendarOpen: false,

            // worklist states
            whatsNeededCS: [],
            assignTo: [],
            assigntoValue: "",
            updateWorklistDetails: {
                Note: '',
                AssignedTo: "",
                WhatsNeeded: "",
                DueDate: "",
                id: [],
                worklistRows: []
            },
            anchorEl: null,
            checkboxForAllRows: false,
            noteRequired: {
                visible: false,
                tagName: ""
            },
            openNotePopup: false,
            viewHistoryData: null,
            viewHistoryPage: 0,
            completed: 0,
            total: 0,
            remaining: 0,
            randomVariableForCancelRunRule: 0,
            showCancellingMsg: false,
            timeElapsed: null
        }
    }

    handleTabValue = (e, tabVal) => {
        this.setState({ tabValue: tabVal });
    }

    handleAutoRunStatus = (autoRunRuleValue) => {
        if (socket) {
            // let autoRunRuleValue = JSON.parse(sessionStorage.getItem("practice"))
            socket.emit("checkAutoRun", {
                practiceId: autoRunRuleValue,
            });

            socket.on("checkAutoRun", (data) => {
                if (data.status === true) {
                    this.setState({ enableAutoRunRuleSetting: true })
                } else {
                    this.setState({ enableAutoRunRuleSetting: false })
                }
                if (data?.pmLinkedStatus === false) {
                    this.setState({
                        pmLinkedStatus: false
                    })
                }
            });
        }
    }

    handleRuleProcesserButton = async () => {
        if (this.state.ruleSuccess === true) {
            this.setState({
                ruleSuccess: false,
                searchValue: '',
                claimsDropdownSelect: 'notRan',
                labelValue: 'Run Encounters'
                // labelValue: 'Claim Center - Not Ran'
            });
            return this.getEncounters(this.state.practiceId1);
        }
    }

    handlePaginationData = (e, newPage) => {
        const offset = newPage * this.state.rowsPerPage;
        this.setState({ page: newPage, offset }, () => {
            this.refreshCurrentListData();
        });
    }

    onRowsPerPage = async (event) => {
        const rowsPerPage = parseInt(event.target.value);
        this.setState({
            rowsPerPage,
            page: 0,
            offset: 0
        }, async () => this.refreshCurrentListData())
    }

    refreshCurrentListData = () => {
        this.cancelPendingReviewedSearch();
        if (this.state.claimsDropdownSelect === 'notRan') {
            this.getEncounters(this.state.practiceId1);
            return;
        }

        if (this.state.formattedRuleDate) {
            this.fetchReviewedList({ date: this.state.formattedRuleDate });
            return;
        }

        this.fetchReviewedList();
    }

    // function to perform auto run rule
    getAutoRunRulesStatus = (AutoRunRulesStatus) => {
        this.setState({ autoRunRuleChecked: AutoRunRulesStatus })
    }

    handleClaimsDropdown = async (e) => {
        const nextClaimsDropdownSelect = e.target.value;
        const nextLabelValue = claimsDropdown.find(item => item.key === nextClaimsDropdownSelect)?.value || '';
        const shouldShowNotRan = nextClaimsDropdownSelect === 'notRan';
        this.setState({
            claimsDropdownSelect: nextClaimsDropdownSelect,
            labelValue: nextLabelValue,
            page: 0,
            offset: 0,
            rowsPerPage: shouldShowNotRan ? 100 : this.state.rowsPerPage,
            pages: shouldShowNotRan ? this.notRanPaginationOptions : this.reviewedPaginationOptions,
            ...(shouldShowNotRan ? {
                ruleSuccess: false,
                rulesData: [],
                rulesDataCopy: [],
                trizettoData: [],
                eligibilityData: [],
                filter_count: 0,
                totalFilteredRecords: 0,
                isFilter: false
            } : {})
        }, () => {
            //New Saurabh Code For Popup
            if (this.state.claimsDropdownSelect != "notRan") {
                this.setState({
                    showPopup: false,
                    showCancelPopup: false,
                }, () => {
                    this.refreshCurrentListData();
                })
            } else {
                this.refreshCurrentListData();
            }
        });
    }

    // function to sort columns
    onSort = (sortKey) => {
        this.setState((prevState) => ({
            sortKey,
            sortDirection: prevState.sortKey === sortKey && prevState.sortDirection === 'asc' ? 'desc' : 'asc'
        }), () => {
            this.setState({ page: 0, offset: 0 }, () => {
                this.refreshCurrentListData();
            });
        });
    }

    hasActiveFilter = (filterState = this.state.filterData) => {
        return Object.values(filterState || {}).some((values) => Array.isArray(values) && values.length > 0);
    }

    cancelPendingReviewedSearch = () => {
        if (this.searchEncounters?.cancel) {
            this.searchEncounters.cancel();
        }
    }

    getReviewedSearchParams = () => {
        const searchKey = this.state.searchKey ? this.state.searchKey : 'primaryInsurance';
        return {
            [searchKey]: this.state.searchValue,
            offset: this.state.offset,
            limit: this.state.rowsPerPage,
            sortKey: this.state.sortKey,
            sortDirection: this.state.sortDirection
        };
    }

    getReviewedStatusQuery = () => {
        return this.setClaimDropdown(this.state.claimsDropdownSelect) || 'isReviewed=true';
    }

    fetchReviewedList = async (options = {}) => {
        this.cancelPendingReviewedSearch();
        const {
            date = this.state.formattedRuleDate,
            filterState = this.state.filterData,
            retryOnEmptyPage = true
        } = options;

        if (this.state.claimsDropdownSelect === 'notRan') {
            return;
        }

        const hasFilter = this.hasActiveFilter(filterState) && this.state.isFilter;
        const requestParams = this.getReviewedSearchParams();

        if (date) {
            let tempDate = new Date(date)
            const year = tempDate?.getFullYear();
            const month = tempDate?.getMonth();
            const day = tempDate?.getDate();
            const utcTimestamp = Date.UTC(year, month, day, 0, 0, 0);
            const finalUTCDate = new Date(utcTimestamp);
            const utcISOString = finalUTCDate?.toISOString();

            if (hasFilter) {
                await this.fetchReviewedFilteredList(filterState, utcISOString, retryOnEmptyPage);
                return;
            }

            await this.fetchReviewedRunRules(utcISOString, requestParams, retryOnEmptyPage);
            return;
        }

        if (hasFilter) {
            await this.fetchReviewedFilteredList(filterState, "", retryOnEmptyPage);
            return;
        }

        await this.fetchReviewedRunRules("", requestParams, retryOnEmptyPage);
    }

    fetchReviewedRunRules = async (utcISOString, requestParams, retryOnEmptyPage = true) => {
        this.setState({ showLoader: true });
        try {
            const params = { ...requestParams };
            if (utcISOString) {
                params.date = utcISOString;
            }
            const response = await API.get(`getRunRules?${this.getReviewedStatusQuery()}`, {
                params
            });
            const filteredData = response.data;
            const rulesData = filteredData.chargeDetail || [];
            const trizettoData = filteredData.eligibilityDetail || [];
            const ruleTrizettoData = filteredData.runRuleDetail || [];

            ruleTrizettoData.sort(function (a, b) {
                return new Date(b.currentTime) - new Date(a.currentTime);
            });

            if (retryOnEmptyPage && this.state.page > 0 && rulesData.length === 0 && filteredData.count_row > 0) {
                const nextOffset = 0;
                this.setState({ page: 0, offset: nextOffset }, () => {
                    this.fetchReviewedList({ date: this.state.formattedRuleDate, retryOnEmptyPage: false });
                });
                return;
            }

            this.setState({
                claimsDropdownSelect: this.state.claimsDropdownSelect,
                labelValue: claimsDropdown.find(item => item.key === this.state.claimsDropdownSelect)?.value || '',
                rulesData,
                rulesDataCopy: rulesData,
                trizettoData: ruleTrizettoData,
                eligibilityData: trizettoData,
                ruleSuccess: response.data.success,
                totalRows: filteredData.count_row,
                count_encounters: filteredData.count_encounters,
                pages: this.reviewedPaginationOptions,
                showLoader: false
            }, () => {
                this.getAssignedUsers();
                this.getWhatsNeeded();
            });
        } catch (err) {
            console.error(err);
            this.setState({ showLoader: false });
        }
    }

    fetchReviewedFilteredList = async (filterState, utcISOString, retryOnEmptyPage = true) => {
        this.setState({ showLoader: true });
        try {
            const filterArray = this.transformFilterStateToFilterArray(filterState);
            if (!filterArray.length) {
                this.setState({ isFilter: false });
                localStorage.removeItem("claimFilter");
                await this.fetchReviewedRunRules(utcISOString, this.getReviewedSearchParams(), retryOnEmptyPage);
                return;
            }

            const body_data = {
                labelValue: this.state.claimsDropdownSelect,
                isReviewed: this.state.claimsDropdownSelect === 'claimsNotReviewed' ? false : true,
                date: this.state.formattedRuleDate ? utcISOString : "",
                filterValues: filterArray,
                searchKey: this.state.searchKey,
                searchValue: this.state.searchValue,
                offset: this.state.offset,
                limit: this.state.rowsPerPage,
                sortKey: this.state.sortKey,
                sortDirection: this.state.sortDirection
            };

            const res = await API.post('filteredDataTable', body_data);
            const data = res?.data || {};
            const finalResult = data?.chargeDetail || [];
            const pagination = data?.pagination || {};
            const totalRecords = pagination.totalRecords ?? 0;

            if (retryOnEmptyPage && this.state.page > 0 && finalResult.length === 0 && totalRecords > 0) {
                this.setState({ page: 0, offset: 0 }, () => {
                    this.fetchReviewedList({ date: this.state.formattedRuleDate, filterState, retryOnEmptyPage: false });
                });
                return;
            }

            this.setState({
                filter_count: data?.count_encounters ?? 0,
                totalFilteredRecords: totalRecords,
                showLoader: false,
                isFilter: true,
                rulesData: finalResult,
                rulesDataCopy: finalResult,
                totalRows: totalRecords,
                count_encounters: data?.count_encounters ?? 0,
                claimsDropdownSelect: this.state.claimsDropdownSelect,
                labelValue: claimsDropdown.find(item => item.key === this.state.claimsDropdownSelect)?.value || '',
                pages: this.reviewedPaginationOptions,
                ruleSuccess: true
            });
            localStorage.setItem("claimFilter", JSON.stringify(filterState));
        } catch (err) {
            console.error(err);
            this.setState({
                filter_count: 0,
                totalFilteredRecords: 0,
                showLoader: false
            });
        }
    }

    // function to change color of heading names when clicked
    colorElement = (index) => {
        if (index === this.state.selectedColumn) {
            this.setState({ selectedColumn: null });
        } else {
            this.setState({ selectedColumn: index });
        }
    }

    // function to show div
    handleShow = (event) => {
        this.setState({ showRule: !this.state.showRule });
    }
    // function to hide div
    handleHide = (event) => {
        this.setState({ showRule: false })
    }

    // function to handle date change
    // handleDateChange = (event, _date) => {
    //     const formattedDate = moment(event).format('YYYY-MM-DD');
    //     this.setState({
    //         formattedRuleDate: event,
    //         labelValue: 'Completed',
    //         claimsDropdownSelect: 'claimsReviewed'
    //     }, () => {
    //         this.getRunRules(event)
    //     });
    // }

    handleDateChange = (event, _date) => {
        console.log("Received event:", event); // What is this the *first* time?
        // Check if the event is a valid date object (not null, undefined, or Invalid Date)
        const isDateValid = moment(event).isValid();
        console.log("Is date valid?", isDateValid); // Is this false the first time?

        if (isDateValid) {
            // If the date is valid, proceed with the existing logic
            const formattedDate = moment(event).format('YYYY-MM-DD');
            console.log("Date selected:", formattedDate);

            this.setState({
                formattedRuleDate: event,
                isCalendarOpen: false,
                labelValue: 'Completed',
                claimsDropdownSelect: 'claimsReviewed',
                page: 0,
                offset: 0
            }, () => {
                this.refreshCurrentListData();
            });

        } else {
            // If the date is not valid (input was cleared/empty)
            console.log("Date cleared. Calling alternative API.");

            // Clear the state related to the date/rules
            this.setState({
                formattedRuleDate: null, // Set state to null to clear the input
                isCalendarOpen: false,
                labelValue: 'Completed', // Reset other relevant states as needed
                claimsDropdownSelect: 'claimsReviewed',
                page: 0,
                offset: 0
            }, () => {
                this.refreshCurrentListData();
            });
        }
    }

    // Handler to open the calendar (for clicking the input)
    handleCalendarOpen = () => {
        this.setState({ isCalendarOpen: true });
    }

    // Handler to close the calendar (if user clicks outside, etc.)
    handleCalendarClose = () => {
        this.setState({ isCalendarOpen: false });
    }

    // function to get run rules
    getRunRules = () => {
        this.fetchReviewedList({ date: this.state.formattedRuleDate });
    }

    // function to handle cell redirect
    handleCell = (id, linkedStatus) => {
        const linkedData = this.state.encounters.filter(f => f.EncounterID === id).map(item => {
            const obj = {}
            obj["pName"] = item.payerName;
            obj["pId"] = item.payerId;
            obj["linkedPayer"] = item.PrimaryInsurancePlanName;
            obj["linkedPayerId"] = item.PrimaryInsurancePolicyPlanID;

            return obj;
        })
        let body_data = {
            rulesRunStatus: this.state.ruleSuccess ? this.state.ruleSuccess : false
        }
        API.post(`getChargesFromLocalId/${id}`, body_data).then((response) => {
            const chargeData = response.data;
            if (this.state.ruleSuccess !== true) {
                this.props.history.push({
                    pathname: `/insurances/${id}/${chargeData[0]?.PrimaryInsurancePolicyPlanID}/Primary`,
                    state: {
                        chargeData: chargeData,
                        linkedData: linkedData,
                        insuranceType: localStorage.getItem("isPrimary") === "true" ? "Primary" : "Secondary",
                        PrimaryInsurancePlanName: chargeData[0]?.PrimaryInsurancePlanName
                    }
                });
            } else {
                this.props.history.push({ pathname: `/insurances/`, state: { chargeData: chargeData.chargeDetails, linkedData: linkedData } });
            }
        }).catch(err => {
            console.error(err);
        });
    }
    // Function to add our give data into cache
    addDataIntoCache = (cacheName, url, response) => {
        const data = new Response(JSON.stringify(response));
        if ('caches' in window) {
            caches.open(cacheName).then((cache) => {
                cache.put(url, data);
            });
        }
    }

    cacheListViewState = () => {
        this.addDataIntoCache('navigateBack', 'goReverse', {
            goReverse: true,
            from: this.state.ruleSuccess ? 'patient-details' : 'inspection-notran',
            search_value: this.state.searchValue,
            searchKey: this.state.searchKey,
            claimsDropdownSelect: this.state.claimsDropdownSelect,
            formattedRuleDate: this.state.formattedRuleDate,
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            offset: this.state.offset,
            sortKey: this.state.sortKey,
            sortDirection: this.state.sortDirection,
            isFilter: this.state.isFilter,
            filterData: this.state.filterData
        });
    }

    handleRow = (id, encounterProcedureId) => {
        let body_data = {
            rulesRunStatus: this.state.ruleSuccess ? this.state.ruleSuccess : false,
            encounterProcedureId: encounterProcedureId
        }
        API.post(`getChargesFromLocalId/${id}`, body_data).then((response) => {
            const chargeData = response.data;
            if (this.state.ruleSuccess !== true) {
                sessionStorage.setItem('viewedDetail', '0') // set 0 for not viewed page and log of action will trigger
                this.cacheListViewState();
                this.props.history.push({ pathname: '/inspection-notran', state: { allChargeData: chargeData } });
            } else {
                let length = this.state.trizettoData.length;
                let chargeInstanceIds = [];
                let eligibilityRes = this.state.eligibilityData.filter(item => item.instanceID === id);
                // localStorage.setItem('isReviewd', chargeData.chargeDetails[0].isMarkReviewed);
                sessionStorage.setItem('viewedDetail', '0') // set 0 for not viewed page and log of action will trigger
                this.cacheListViewState();
                this.props.history.push({
                    // pathname: '/inspection-noviolation',
                    pathname: '/patient-details',
                    state: {
                        chargeData: chargeData.chargeDetails[0],
                        allChargeData: chargeData.chargeDetails,
                        trizettoData: chargeData.runRuleDetails,
                        eligibilityData: eligibilityRes,
                        trizettoDate: this.state.trizettoData[length - 1],
                        from: 'rule-processor',
                        rulesRanBy: chargeData.ruleRanBy,
                        isBypassed: chargeData.isBypassed,
                        claimsDropdownSelect: this.state.claimsDropdownSelect,
                        ruleSuccess: this.state.ruleSuccess,
                        encounterProcedureId: encounterProcedureId,
                        instanceId: chargeData.chargeDetails[0].instanceID,
                        isReviewed: chargeData.chargeDetails[0].isMarkReviewed
                        // searchEncounters: this.searchEncounters(),
                        // draftEnounters: this.getEncounters()
                    }
                });
            }
            this.setState({ chargeData: chargeData });
        }).catch(err => {
            console.error(err);
        });
    }

    // function to handle single select checkbox
    handleSingleSelect = (event) => {
        const { selectedValues } = this.state;
        const selectedIndex = event.target.value;
        if (!selectedValues.includes(selectedIndex)) {
            let checkedCount = selectedValues.length;
            this.setState({ selectedValues: [...selectedValues, selectedIndex] });
            if (checkedCount === 29) {
                this.setState({ message: NotificationManager.info('30 encounters have already been selected', 'Message!', 5000) })
            }
        } else {
            this.setState({
                selectedValues: selectedValues.filter((index) => {
                    return index !== selectedIndex;
                })
            })
        }
    }

    // function to handle check all rows
    handleCheckAll = () => {
        const { selectedValues, encounters } = this.state;
        if (selectedValues.length < encounters.length) {
            this.setState({
                selectedValues: encounters.map(x => x.EncounterID)
            });
        } else {
            this.setState({ selectedValues: [] });
        }
    }

    handlePMConnection = () => {
        this.setState({
            pmLinkedStatus: JSON.parse(sessionStorage.getItem('practice'))?.PMLinkedStatus
        })
    }

    // function to get encounters
    getEncounters = (practiceId) => {
        this.setState({
            isLoading: true,
            showLoader: true,
            ruleSuccess: false,
            encounters: [],
            encountersCopy: [],
            rulesData: [],
            rulesDataCopy: [],
            trizettoData: [],
            eligibilityData: [],
            rowsPerPage: 100,
            pages: this.notRanPaginationOptions
        });
        let practiceData = JSON.parse(sessionStorage.getItem("practice"));
        let client = JSON.parse(sessionStorage.getItem("clientDetail"));
        // practiceId = practiceData?.id;
        // LoadingSpinner.show()
        API.get(`getChargesFromLocal/${practiceId}/Draft`, {
            params: {
                offset: this.state.offset,
                limit: this.state.rowsPerPage,
                sortKey: this.state.sortKey,
                sortDirection: this.state.sortDirection
            }
        }).then((response) => {
            this.setState({ showLoader: false })
            if (response.data.result.status === 400) {
                this.setState({
                    localDate: response.data.result.date,
                    filterDateType: response.data.result.filterDateType,
                    fromDate1: response.data.result.fromDate,
                    toDate1: response.data.result.toDate,
                })
            } else {
                if (response.data.result.result.length > 0) {
                } else {
                    NotificationManager.error('No records found for the date range!', 'Failure!', 3000);
                }
                const encounters = response.data.result;
                if (encounters.result.length === 0) {
                    this.setState({
                        encounters: [],
                        encountersCopy: [],
                        ruleSuccess: null,
                        encounterCount: 0,
                        localDate: response.data.result.date,
                        filterDateType: response.data.result.filterDateType,
                        fromDate1: response.data.result.fromDate,
                        toDate1: response.data.result.toDate,
                    });
                } else {
                    this.setState({
                        encounters: encounters.result,
                        encountersCopy: encounters.result,
                        encounterCount: encounters.count,
                        isLoading: false,
                        localDate: encounters.result[0].date,
                        filterDateType: encounters.result[0].filterDateType,
                        fromDate1: encounters.result[0].fromDate,
                        toDate1: encounters.result[0].toDate,
                        practiceId1: this.state.practiceId1,
                        ruleSuccess: false,
                        providerType: encounters.providerType ? encounters.providerType : client.providerType
                    }, () => {
                        if (this.state.isFilter) {
                            this.applySavedFilter()
                        }
                    });
                }
            }
            // LoadingSpinner.hide()
        }).catch(err => {
            console.error(err);
            this.setState({ showLoader: false })
            // LoadingSpinner.hide()
        })
    }

    getCharges = (practiceId) => {
        let { selectDateType, fromDate, toDate } = this.state;
        this.setState({ showChargesPopup: false, showRunningCharges: !this.state.showRunningCharges, showCancelRunningCharges: false });
        let chargesTimer = setTimeout(() => this.setState({ showCancelRunningCharges: !this.state.showCancelRunningCharges }), 15000)
        localStorage.setItem("refreshState", true);
        let practiceData = JSON.parse(sessionStorage.getItem("practice"))
        let body_data = {
            practiceId: practiceData.id,
            dateType: selectDateType,
            fromDate: fromDate ? (new Date(fromDate)).toLocaleDateString('en-US') : (new Date(myPastDate)).toLocaleDateString('en-US'),
            toDate: toDate ? (new Date(toDate)).toLocaleDateString('en-US') : (new Date(currentToDate)).toLocaleDateString('en-US'),
            userToken: JSON.parse(sessionStorage.getItem("token")).token,
            lastUpdatedDate: Date.now()
        }
        API.post('kareo/getCharges', body_data, {
            headers: {
                CustomerKey: practiceData.key,
                User: practiceData.email,
                Password: practiceData.password,
                PracticeName: practiceData.practiceName
            }
        }).then((response) => {
            if (this.state.pmLinkedStatus === false) {
                this.setState({
                    autoRunRuleChecked: false,
                    showChargesTryAgain: true,
                    showRunningCharges: false,
                    showCancelRunningCharges: false
                });
            }
            else {
                if (response.data.result.ruleProcessor.length > 0) {
                    clearTimeout(chargesTimer);
                    NotificationManager.success('Data successfully retrieved!', 'Successful!', 9000);
                    setTimeout(() => window.location.reload(), 2000)
                } else {
                    NotificationManager.error('No records found for the date range!', 'Failure!', 5000);
                    this.setState({
                        selectDateType: 'createdDate',
                        fromDate: myPastDate,
                        toDate: currentToDate
                    })
                }
                localStorage.setItem("refreshState", false);
                const encounters = response.data.result;
                let draftArray = []; let draftEncounters;
                if (encounters.ruleProcessor.length === 0) {
                    draftEncounters = []
                } else {
                    encounters.ruleProcessor.forEach((encounter, i) => {
                        draftArray.push(encounter.getChargeData);
                    })
                    draftEncounters = draftArray.filter(item => item.EncounterStatus === 'Draft');
                }
                this.setState(prevState => ({
                    showRunningCharges: false,
                    encounters: draftEncounters,
                    encountersCopy: draftEncounters,
                    isLoading: false,
                    date: response.data.date,
                    practiceId: draftEncounters.length > 0 ? draftEncounters[0].PracticeID : '',
                    filterDateType: encounters.filterDateType,
                    fromDate1: encounters.fromDate,
                    toDate1: encounters.toDate
                }));
            }
        }).catch(err => {
            NotificationManager.error('Data cannot be fetched', 'Error!', 5000);
            this.setState({
                showChargesTryAgain: true,
                showRunningCharges: false,
                showCancelRunningCharges: false
            });
            console.error(err);
        })
        // }
    }

    // function to handle charges pop up
    OpenChargesPopup = () => {
        this.setState({ showChargesPopup: true })
    }
    closeChargesPopup = () => {
        this.setState({ showChargesPopup: false, selectDateType: 'createdDate', fromDate: myPastDate, toDate: new Date() });
    }

    // function to handle charges dropdown
    handleChargesDropdown = (e) => {
        const { value } = e.target;
        this.setState({ selectDateType: value });
    }

    // function to handle charges date change
    handleFromDate = (e) => {
        this.setState({ fromDate: e });
    }
    handleToDate = (e) => {
        this.setState({ toDate: e });
    }

    // function to validate date difference
    isDateValid = () => {
        const { fromDate, toDate } = this.state;

        let formattedFromDate = (new Date(fromDate ? fromDate : myPastDate)).toLocaleDateString('en-US');
        let formattedToDate = (new Date(toDate ? toDate : currentToDate)).toLocaleDateString('en-US');

        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const validFromdate = new Date(formattedFromDate);
        const validToDate = new Date(formattedToDate);

        const diffDays = Math.round(Math.abs((validFromdate - validToDate) / oneDay));
        if (diffDays > 60) {
            NotificationManager.error('Date range exceeded 60 days', 'Error!', 5000);
        } else {
            this.getCharges();
        }
    }

    // logic to search encounters by dropdown selection
    handleSelectChange = (e) => {
        this.setState({ selectedColumnData: [], selectedColumnDataCopy: [], page: 0, offset: 0 })
        // let value = searchItems.filter(item => {
        //     return item.key === e.target.value
        // })
        // if (this.state.searchValue !== '') {
        //     this.searchEncounters()
        // }
        // this.setState({
        //     searchKey: value ? value[0].key : 'primaryInsurance',
        //     searchValue: '',
        //     // optionSelector: false,
        //     draftPlaceholder: value[0].value
        // });
        let { value } = e.target;

        const updatedSearchItems = [
            { key: 'assignedTo', value: 'Assigned To', data: 'AssignedTo' }, // New start object
            ...searchItems,
            { key: 'whatsNeeded', value: 'What needed', data: 'WhatsNeeded' } // New end object
        ];
        let searchDataKey = (this.state.claimsDropdownSelect != "notRan" ? updatedSearchItems : searchItems)?.find(item => item?.key == value)?.data
        this.setState({
            searchKey: value,
            searchName: (this.state.claimsDropdownSelect != "notRan" ? updatedSearchItems : searchItems)?.find(item => item.key == value)?.value,
            searchData: (this.state.claimsDropdownSelect != "notRan" ? updatedSearchItems : searchItems)?.find(item => item.key == value)?.data,
            showSearch: true,
            showCheckedValues: false,
            checkboxValues: this.state.filterData[searchDataKey] ? this.state.filterData[searchDataKey] : []
        }, () => {
            this.handleDropdownData(value);
        })
    }
    handleDropdownData = (type) => {
        this.setState({ apiLoading: true })
        let body_data = {
            date: this.state.formattedRuleDate ? this.state.formattedRuleDate : false,
            label: type,
            labelValue: this.state.claimsDropdownSelect
        }
        API.post('searchByColumnValuesInRP', body_data).then((res) => {
            let data = res.data.data;
            if (type == "assignedTo" || type == "whatsNeeded") data.unshift({ id: "unassigned", full_name: "Unassigned" })
            this.setState({ apiLoading: false, selectedColumnData: data, selectedColumnDataCopy: data })
        }).catch(err => {
            console.error(err);
        })
    }
    searchFilterValues = (value) => {
        this.setState({ filterKey: value });
        let searchResult = this.state.selectedColumnDataCopy.filter((item) => {
            if (
                item.toUpperCase().indexOf(value.toUpperCase()) !== -1
            ) {
                return item;
            }
        });
        this.setState({ selectedColumnData: searchResult });
    };

    // function to handle checkbox values for filter
    handleCheckboxValues = (e) => {
        const { value } = e.target;
        const { checkboxValues } = this.state;
        const newSearchData = this.state.filterData
        let selectedVal = value;
        if (!checkboxValues.includes(selectedVal)) {
            this.setState({ checkboxValues: [...checkboxValues, selectedVal] });
            newSearchData[this.state.searchData] = [...checkboxValues, selectedVal]
            this.setState({ filterData: newSearchData });
        } else {
            const newFilterObj = checkboxValues.filter((index) => {
                return index !== selectedVal;
            })
            this.setState({
                checkboxValues: newFilterObj
            })
            newSearchData[this.state.searchData] = newFilterObj ? newFilterObj : []
            this.setState({ filterData: newSearchData });
        }
    }

    // function to handle apply
    handleGoBack = () => {
        this.setState({
            showCheckedValues: true,
            showSearch: false,
            // filteredValues: [...filteredValues, { label: searchKey, values: checkboxValues, title: searchName }],
            searchKey: ''
        })
    }

    // function to handle go back checkbox selection
    handleGoBackCheckbox = (title, values) => {
        const { filterData } = this.state;
        const newFilterData = filterData[title]?.filter(item => item != values)
        const newFilterObj = filterData
        newFilterObj[title] = newFilterData ? newFilterData : []
        this.setState({ filterData: newFilterObj });
        this.setState({ goBackCheckbox: `${title}: ${values}` })
    }

    // function to filter draft table based on selected filters
    // filterTable = async () => {
    //     const { searchKey, checkboxValues, filteredValues, searchName } = this.state;
    //     await this.setState({ filteredValues: [...filteredValues, { label: searchKey, values: checkboxValues, title: searchName }] })
    //     await this.filterSearchFunction();
    // }
    // filterSearchFunction = async () => {
    //     let values = [...new Set(this.state.filteredValues)]
    //     const body_data = values;
    //     API.post('searchRowsByColumnItemInRP', body_data).then(res => {
    //         let filteredEncounters = res.data.data;
    //         let encounterLength = res.data.length;
    //         this.setState({
    //             encounters: filteredEncounters,
    //             encounterCount: encounterLength,
    //             ruleSuccess: false,
    //             optionSelector: !this.state.optionSelector,
    //             selectedColumnData: [],
    //             selectedColumnDataCopy: [],
    //             showSearch: false,
    //             searchKey: '',
    //             showCheckedValues: true
    //         });
    //     }).catch(err => {
    //         console.error(err);
    //     })
    // }

    // filterTable = async () => {
    //     const { encounters, filterData, rulesDataCopy, claimsDropdownSelect, checkboxValues } = this.state;
    //     let keys = Object.keys(filterData)
    //     let finalResult = claimsDropdownSelect == "notRan" ? encounters : rulesDataCopy;
    //     await keys.map(key => {
    //         if (filterData[key].length != 0) {
    //             finalResult = finalResult?.filter(item => filterData[key]?.includes(item[key]))
    //         }
    //     })
    //     if (claimsDropdownSelect == "notRan") {
    //         this.setState({ encounters: finalResult })
    //     } else {
    //         this.setState({ rulesData: finalResult })
    //     }
    //     this.setState({
    //         // encounters: finalResult,
    //         // rulesData: finalResult,
    //         optionSelector: false,
    //         showSearch: false,
    //         showCheckedValues: checkboxValues.length > 0 ? true : false
    //     })
    //     localStorage.setItem('claimFilter', JSON.stringify(filterData))
    // }

    // function to clear filter values
    clearFilter = () => {
        this.setState({
            optionSelector: false,
            showSearch: false,
            showCheckedValues: false,
            searchKey: '',
            checkboxValues: [],
            apiLoading: false,
            isFilter: false,
            filterData: {
                EncounterID: [],
                ServiceLocationName: [],
                ProcedureCode: [],
                ServiceStartDate: [],
                SchedulingProviderName: [],
                PrimaryInsurancePlanName: [],
                EncounterDiagnosisID1: [],
                PatientName: []
            }
        }, () => {
            if (this.state.ruleSuccess) {
                this.setState({ page: 0, offset: 0 }, () => this.refreshCurrentListData())
            } else {
                this.getEncounters(this.state.practiceId1);
            }
        })
        localStorage.removeItem("claimFilter");
    }

    handleInputChange = (event) => {
        this.setState({ searchValue: event.target.value, offset: 0, page: 0 }, () => {
            this.searchEncounters();
        });
    }

    selectHandler = (e) => {
        this.setState({
            optionSelector: !this.state.optionSelector,
            searchKey: '',
            selectedColumnData: [],
            showSearch: false,
            apiLoading: false
        })
    }

    handleClaimChange = (e) => {
        let value = claimsDropdown.filter(item => {
            return item.key === e.target.value
        })
        this.setState({
            claimKey: value ? value[0].key : 'PrimaryInsurancePlanName',
            claimSelector: false,
            labelValue: value[0].value
        })
    }

    claimHandler = (e) => {
        this.setState({ claimSelector: !this.state.claimSelector })
    }

    closeClaimsDropdown = () => {
        if (this.state.claimSelector) {
            this.setState({ claimSelector: false });
        }
    }

    searchEncounters = _.debounce(() => {
        if (this.state.enableAutoRunRuleSetting === false) {
            if (this.state.claimsDropdownSelect === 'notRan') {
                this.getEncounters(this.state.practiceId1);
                return;
            }

            if (this.state.claimsDropdownSelect === 'claimsReviewed' || this.state.claimsDropdownSelect === 'claimsNotReviewed') {
                this.fetchReviewedList();
            }
        }
    }, 1000);

    setClaimDropdown = (claimValue) => {
        switch (claimValue) {
            case 'claimsNotReviewed':
                return 'isReviewed=false'
            case 'claimsReviewed':
                return 'isReviewed=true'
            // case 'ranByDay':
            //     const dateSelect = this.state.formattedRuleDate;
            //     if (!dateSelect) {
            //         NotificationManager.error('Add a date to use this selected option', 'Failed!', 3000)
            //         return;
            //     }
            //     return 'date=' + moment(this.state.formattedRuleDate).format('YYYY-MM-DD')
            // case 'notRan':
            default:
                return
        }
    }

    // API to get last created rule
    getLastRule = () => {
        API.get('getLastRule').then((response) => {
            const lastRule = response.data.data;
            this.setState({ getLastRule: lastRule });
        }).catch(err => {
            console.error(err);
        })
    }

    // API to get draft list from practice
    getDraftList = (practiceId) => {
        API.get(`getChargesFromLocal/${practiceId}/Draft`, {
            params: {
                offset: this.state.offset,
                limit: this.state.rowsPerPage,
                sortKey: this.state.sortKey,
                sortDirection: this.state.sortDirection
            }
        }).then((response) => {
            const draftList = response.data.result;
            this.setState({ encounters: [] });
            this.setState({ encounters: draftList, encountersCopy: draftList })
        }).catch(err => {
            console.error(err);
        })
    }

    // API to get rejected list from practice
    getRejectedList = () => {
        API.get('getChargesFromLocal/Rejected').then((response) => {
            const rejectedList = response.data.result;
            this.setState({ encounters: rejectedList });
        }).catch(err => {
            console.error(err);
        })
    }


    // handle run rules based on provider status
    handleRunRules = () => {
        let { encounters, selectedValues } = this.state;
        let notActiveDataArray = [];
        const encounterData = encounters.filter((item) => selectedValues.includes(item.EncounterID));
        notActiveDataArray = encounterData.filter(item => item.RenderingProviderStatus === false);
        // console.log('Rules Ran', notActiveDataArray);
        if (client?.defaultChargePerProvider === true && notActiveDataArray.length > 0) {
            this.setState({ showProviderPopUp: true });
        } else {
            this.runRules();
        }
    }

    // function to cancel running encounters
    handleCancelRunRule = () => {
        const data_body = {
            variable: this.state.randomVariableForCancelRunRule
        }
        API.post('trizetto/cancelRunRule', data_body, {
            headers: {
                // CustomerKey: practiceData.key,
                // User: practiceData.email,
                // Password: practiceData.password,
                // PracticeName: practiceData.practiceName,
                // Variable: randomVariable
            }
        }).then((response) => {
            clearTimeout(rulesTimer);
            NotificationManager.success('Encounter Running Cancel', 'Successful!', 3000);
        }).catch(err => {
            NotificationManager.error('There was an error while running the rules', 'Error!', 5000);
            console.error(err);
        })
    }

    // API to run eligibility
    runRules = () => {
        let { encounters, selectedValues } = this.state;
        this.setState({ showProviderPopUp: false });
        if (selectedValues.length > 0) {
            let activeDataArray = [];
            const encounterData = encounters.filter((item) => selectedValues.includes(item.EncounterID));
            activeDataArray = encounterData.filter(item => item.RenderingProviderStatus === true);
            let dataArray = []; let encounterIds = []; let providerStatus;
            let practiceData = JSON.parse(sessionStorage.getItem("practice"));
            let client = JSON.parse(sessionStorage.getItem("clientDetail"));
            (client.defaultChargePerProvider === true ? activeDataArray : encounterData).forEach((data, index) => {
                // code to get first & last name of provider
                let providerName = data.SchedulingProviderName;
                let providerArr = [];
                let x = providerName.split(",")[0];
                let z = x.split(" ")
                z.pop()
                for (let i = 0; i < z.length + 1; i++) {
                    let y = x.split(" ")[i]
                    providerArr.push(y)
                }
                let providerFirstName = providerArr[0];
                let providerLastName = providerArr[z.length]
                let patientFirstName = data.PatientFirstName;
                let patientLastName = data.PatientLastName;

                // code to get date of birth in the required format
                function DateConverter(dateOfBirth) {
                    if (dateOfBirth !== "") {
                        let dob = dateOfBirth;
                        let x2 = dob.split("/");
                        let patientDob = x2[2] + x2[0] + x2[1]
                        return patientDob;
                    } else {
                        return dateOfBirth;
                    }
                }

                let serviceDate = data.ServiceStartDate;
                var dateOfService = serviceDate.replace(/(\d\d)\/(\d\d)\/(\d{4})/, "$3$1$2");

                let { token } = JSON.parse(sessionStorage.getItem("token"));
                providerStatus = data.RenderingProviderStatus

                let body_data = {
                    GediPayerID: data.payerId,
                    EncounterID: data.EncounterID,
                    PatientID: data.PatientID,
                    isDuplicate: false,
                    ProviderFirstName: "",
                    ProviderLastName: practiceData.practiceName,
                    NPI: practiceData.groupNPI,
                    // NPI: '1558427526',
                    InsuranceNum: data.PrimaryInsurancePolicyNumber,
                    InsuredFirstName: patientFirstName,
                    InsuredLastName: patientLastName, // condition to be applied (patient relation to insured)
                    InsuredDob: DateConverter(data.PatientDateOfBirth), // condition to be applied (patient relation to insured)
                    InsuredGender: data.Gender, // condition to be applied (patient relation to insured)
                    // SubscriberFirstName: data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? patientFirstName : patientFirstName,
                    // SubscriberLastName: data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? patientLastName : patientLastName,
                    // SubscriberDob: data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? DateConverter(data.PatientDateOfBirth) : DateConverter(data.PatientDateOfBirth),
                    // // SubscriberDob: data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? patientDob : DateConverter(data.PrimaryInsurancePolicyInsuredDateOfBirth),
                    // SubscriberGender:  data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? data.Gender : data.Gender,
                    // SubscriberGender:  data.PrimaryInsurancePolicyPatientRelationshipToInsured === 'S' ? data.Gender : data.PrimaryInsurancePolicyInsuredGender,
                    DependentFirstName: patientFirstName,
                    DependentLastName: patientLastName,
                    DependentDob: DateConverter(data.PatientDateOfBirth),
                    DependentGender: data.Gender,
                    DateOfService: dateOfService,
                    userToken: token,
                    renderingProviderStatus: providerStatus
                }
                dataArray.push(body_data);
                encounterIds.push(data.EncounterID);
            })
            const randomVariable = Math.floor(Math.random() * (999 - 100 + 1) + 100);
            if (dataArray.length > 0) {
                this.setState({ showPopup: !this.state.showPopup });
                rulesTimer = setTimeout(() => this.setState({ showCancelPopup: true }), 5 * 60 * 1000)
                API.post('trizetto/DoInquiry_KareoUpdateEncounterStatus', dataArray, {
                    headers: {
                        CustomerKey: practiceData.key,
                        User: practiceData.email,
                        Password: practiceData.password,
                        PracticeName: practiceData.practiceName,
                        variable: randomVariable,
                        requestType: "Manual"
                    }
                }).then((res) => {
                    NotificationManager.success('Encounter start running!', 'Successful!', 3000);
                    this.setState({
                        showRulesTryAgain: false,
                        showPopup: true,
                        showCancelPopup: false,
                        // total: dataArray.length,
                        // remaining: dataArray.length,
                        randomVariableForCancelRunRule: randomVariable
                    });
                }).catch(err => {
                    NotificationManager.error('There was an error while running the rules', 'Error!', 5000);
                    console.error(err);
                })
            }
        } else {
            NotificationManager.error('Please select atleast one encounter to run the rules', 'Error!', 5000);
        }
    }

    handleCheckboxChange = (event, formKey) => {
        const { name, checked } = event.target;
        const updatedCheckedItems = { ...this.state.checkedItems, [name]: checked };
        let checkedCount = Object.values(updatedCheckedItems).filter((value) => value).length;

        this.setState({
            checkedItems: updatedCheckedItems,
            count: checkedCount,
            message: checkedCount > 29 ? NotificationManager.info('30 encounters have alread been selected', 'Message!', 3000) : null
        });
    }

    getCacheData = async (cache_name, key) => {

        var names = await caches.keys()
        const cacheStorage = await caches.open(cache_name);

        const cachedResponse = await cacheStorage.match(key);
        if (cachedResponse) {
            return await cachedResponse.json()
        } else {
            return false
        }
    }

    deleteSpecificCache = (cacheName) => {
        if ("caches" in window) {
            caches.delete(cacheName).then(function (res) {
                return res;
            });
        }
    }

    // function to update auto run rule in practice
    updatePractice = (autoRunRules) => {
        return new Promise((resolve, reject) => {
            const data = {
                autoRunRules: autoRunRules,
            }
            API.put(`updatePractice/${this.state.practiceId1}`, data).then(({ data }) => {
                sessionStorage.setItem(this.SESSION_PRACTICE_KEY, JSON.stringify(data.data))
                this.setState({
                    autoRunRuleChecked: autoRunRules
                })
                this.state.refreshPractice()
                resolve(true)
                NotificationManager.success('Auto-run Rules has been updated successfully!', 'Successful!', 3000);
            }).catch(err => {
                NotificationManager.error('An error occured while updating the Auto-run Rules', 'Failed!', 3000);
            })
        })
    }

    // function to edit last rule
    editLastRule = (id) => {
        let ruleDetail = this.state.getLastRule;
        let length = ruleDetail[0].ruleInfo.length;
        let obj = {
            for: ruleDetail[0].ruleInfo[length - 1].operator,
            pendValue: ruleDetail[0].result,
            reason: ruleDetail[0].Reason,
            operator: "none"
        }
        ruleDetail[0].ruleInfo.push(obj);
        this.props.history.push({
            pathname: `/edit-rule/${id}`,
            state: {
                editRule: true,
                ruleDetail: ruleDetail[0],
                tags: ruleDetail[0].tags,
                ruleId: id,
                path: `/edit-rule/${id}`
            }
        });
    }


    transformFilterStateToFilterArray = (filterState) => {
        const filterArray = [];

        // Map specific keys from filterState back to generic "labels" for the API
        const keyMapping = {
            "EncounterID": "encounter",
            "ServiceLocationName": "facility",
            "ProcedureCode": "procedureCode",
            "ServiceStartDate": "dateOfService",
            "SchedulingProviderName": "schedulingProvider",
            "PrimaryInsurancePlanName": "primaryInsurance",
            "EncounterDiagnosisID1": "DXC1",
            "PatientName": "patientName",
            "AssignedTo": "assignedTo",
            "WhatsNeeded": "whatsNeeded"
        };

        // Iterate over all keys in the incoming filterState
        for (const key in filterState) {
            if (Object.hasOwnProperty.call(filterState, key)) {
                const values = filterState[key];

                // Only add filters that have actual values
                if (Array.isArray(values) && values.length > 0) {
                    // Find the appropriate label name from our mapping (if it exists)
                    const label = keyMapping[key] || key;

                    filterArray.push({
                        label: label,
                        values: values
                    });
                }
            }
        }
        return filterArray;
    };


    // Make the function an 'async' function
    filteredData = async (filterState) => {
        const { claimsDropdownSelect, formattedRuleDate } = this.state;
        let utcISOString;
        if (formattedRuleDate) {
            let tempDate = new Date(formattedRuleDate)
            if (!isNaN(tempDate)) {
                const year = tempDate?.getFullYear();
                const month = tempDate?.getMonth(); // 0 for Jan, 10 for Nov
                const day = tempDate?.getDate();

                const utcTimestamp = Date.UTC(year, month, day, 0, 0, 0);
                const finalUTCDate = new Date(utcTimestamp);
                utcISOString = finalUTCDate?.toISOString();
            }
        }
        const filterArray = this.transformFilterStateToFilterArray(filterState);

        // ✅ Early return when no filters
        if (!filterArray.length) {
            this.clearFilter();
            localStorage.removeItem("claimFilter"); // optional but safer
            return { cleared: true };
        }
        try {
            LoadingSpinner.show();
            const body_data = {
                labelValue: claimsDropdownSelect,
                date: formattedRuleDate ? utcISOString : "",
                filterValues: filterArray,
                offset: this.state.offset,
                limit: this.state.rowsPerPage,
                sortKey: this.state.sortKey,
                sortDirection: this.state.sortDirection
            };
            const res = await API.post('filteredDataTable', body_data);
            const data = res?.data || {};

            const finalResult = data?.chargeDetail || [];
            const pagination = data?.pagination || {};

            this.setState({
                filter_count: data?.count_encounters ?? 0,
                totalFilteredRecords: pagination.totalRecords ?? 0,
            });
            // ✅ Persist only on successful filter usage
            localStorage.setItem("claimFilter", JSON.stringify(filterState));
            return finalResult;
        } catch (err) {
            console.error(err);
            // ✅ Ensure consistent fallback state
            this.setState({
                filter_count: 0,
                totalFilteredRecords: 0
            });
            return { failed: true };
        } finally {
            // ✅ Always clears loader (success + error)
            LoadingSpinner.hide();
        }
    }

    // function to handle provider pop up
    handleProviderPopup = () => {
        this.setState({ showProviderPopUp: !this.state.showProviderPopUp, selectedValues: [] });
    }

    performFiltering = async (data, filterState) => {
        const result = await this.filteredData(filterState);
        return result;
    };

    filterTable = async () => {
        const { encountersCopy, filterData, rulesDataCopy, claimsDropdownSelect } = this.state;
        // Log the initial data and the filter values BEFORE the filter is applied
        const initialData = claimsDropdownSelect === 'notRan' ? encountersCopy : rulesDataCopy;
        this.cancelPendingReviewedSearch();
        this.setState({ page: 0, offset: 0 }, async () => {
            const finalResult = await this.performFiltering(initialData, filterData);
            if (finalResult?.failed) {
                return;
            }
            if (finalResult?.cleared) {
                return;
            }
            let filterCount = Array.isArray(finalResult) ? finalResult?.map(item => item.EncounterID) : [];

            this.setState(prevState => {
                const updatedState = {
                    optionSelector: false,
                    showSearch: false,
                    isFilter: true,
                    filterClaims: filterCount?.length,
                    showCheckedValues: prevState.checkboxValues.length > 0
                };
                if (prevState.claimsDropdownSelect === 'notRan') {
                    updatedState.encounters = finalResult;
                } else {
                    updatedState.rulesData = finalResult;
                }
                return updatedState;
            });
        });
    };

    // new addition for External User
    getStoredPractice = () => {
        const practiceRaw = sessionStorage.getItem('practice');
        if (!practiceRaw || practiceRaw === 'undefined') return null;

        try {
            const practice = JSON.parse(practiceRaw);
            return practice?.id ? practice : null;
        } catch (err) {
            return null;
        }
    };

    waitForPracticeAndLoad = () => {
        if (this.practiceWaitTimer) {
            clearInterval(this.practiceWaitTimer);
        }

        this.practiceWaitTimer = setInterval(() => {
            const practice = this.getStoredPractice();

            if (!practice?.id) return;

            clearInterval(this.practiceWaitTimer);
            this.practiceWaitTimer = null;

            this.setState(
                {
                    practiceId1: practice.id,
                    pmLinkedStatus: practice.PMLinkedStatus,
                    claimsDropdownSelect: 'claimsNotReviewed',
                    labelValue: 'Worklist',
                    page: 0,
                    offset: 0
                },
                () => this.refreshCurrentListData()
            );
        }, 150);
    };

    async componentDidMount() {
        this.getLastRule();
        this.handlePMConnection();

        localStorage.setItem("refreshState", false);
        localStorage.setItem("isPrimary", false);

        // Use local variables to avoid direct global assignments if possible
        const client = JSON.parse(sessionStorage.getItem("clientDetail"));
        const user = JSON.parse(sessionStorage.getItem("userDetail"));
        const autoRunRuleValue = JSON.parse(sessionStorage.getItem("practice"));
        const clientKey = await getClientKey();
        if (autoRunRuleValue) {
            this.setState({ autoRunRuleChecked: autoRunRuleValue?.autoRunRules })
        }

        // 1. Initialize Sockets Immediately
        if (socket) {
            // Request current status immediately in case rules are already running
            socket.emit("checkAutoRun", { practiceId: autoRunRuleValue?.id });
            setInterval(() => {
                socket.emit("trackRanEncounter", { practiceId: this.state.practiceId1 });
            }, 500)

            // Listen for rule progress (This handles the "appearing for others" part)
            socket.on("trackRanEncounter", (data) => {
                // Only update if it belongs to this client and practice
                if (clientKey === data.clientKey && data.practiceId == this.state.practiceId1 && this.state.claimsDropdownSelect == "notRan") {

                    // Case: Rule is currently in progress
                    if (data.total > 0 && data.remaining > 0 && data.signal == "Running") {
                        if (this.state.showPopup) {
                            this.setState({
                                completed: Number(data.completed) + 1,
                                total: data.total,
                                remaining: Number(data.remaining) - 1,
                                timeElapsed: data.timeTaken,
                            });
                        } else {
                            this.setState({
                                completed: Number(data.completed) + 1,
                                total: data.total,
                                remaining: Number(data.remaining) - 1,
                                timeElapsed: data.timeTaken,
                                showRulesTryAgain: false,
                                showPopup: true,
                                showCancelPopup: false,
                                randomVariableForCancelRunRule: data.variable
                            });
                            rulesTimer = setTimeout(() => this.setState({ showCancelPopup: true }), 5 * 60 * 1000)
                        }
                    }
                    // Case: Rule finished or was cancelled
                    if ((data.remaining === 0 || data.completed === data.total || data.signal === "Completed")) {
                        clearTimeout(rulesTimer);
                        NotificationManager.success('Rules Ran successful!', 'Successful!', 3000);
                        this.setState({
                            rulesRan: true,
                            showPopup: false,
                            showCancelPopup: false,
                            showCancellingMsg: false,
                            ruleDate: data.currentDate,
                            claimsDropdownSelect: 'claimsNotReviewed',
                            labelValue: 'Worklist',
                            selectedValues: [],
                            completed: 0,
                            total: 0,
                            remaining: 0,
                            rowsPerPage: 100,
                            pages: this.notRanPaginationOptions
                        }, () => {
                            this.setState({ page: 0, offset: 0 }, () => this.refreshCurrentListData());
                        });
                    }
                    if (data.signal == "Cancelling") {
                        this.setState({
                            completed: Number(data.completed) + 1,
                            total: data.total,
                            remaining: Number(data.remaining) - 1,
                            timeElapsed: data.timeTaken,
                            showPopup: true,
                            showCancelPopup: false,
                            showCancellingMsg: true
                        });
                    }
                }
            });

            socket.on("checkAutoRun", (data) => {
                if (clientKey === data.clientKey && autoRunRuleValue?.id === data.data?.id) {
                    this.setState({ enableAutoRunRuleSetting: !!data.status });
                    if (data?.pmLinkedStatus === true) {
                        window.location.reload();
                    }
                }
            });

            socket.on('disconnect', () => {
                this.setState({ enableAutoRunRuleSetting: false });
            });
        }

        // 2. Handle Navigation / History Logic
        const { state } = this.props.location;
        const initialClaimsSelect = (state && state.claimsDropdownSelect) || 'notRan';
        const oldPageDetail = await this.getCacheData('navigateBack', 'goReverse');

        if (initialClaimsSelect == 'notRan' && !oldPageDetail.goReverse && !this.props.history.location.state && user.roleId != 9) {
            this.getEncounters();
        }

        if (oldPageDetail.goReverse) {
            let value = claimsDropdown.filter(item => item.key === oldPageDetail.claimsDropdownSelect);
            const restoredRowsPerPage = oldPageDetail.rowsPerPage || this.state.rowsPerPage;
            const restoredPage = oldPageDetail.page || 0;
            const restoredFilterData = oldPageDetail.filterData || JSON.parse(localStorage.getItem('claimFilter'));
            const restoredIsNotRan = oldPageDetail.claimsDropdownSelect === 'notRan';
            const effectiveRowsPerPage = restoredIsNotRan ? 100 : restoredRowsPerPage;
            this.setState({
                page: restoredPage,
                rowsPerPage: effectiveRowsPerPage,
                offset: restoredPage * effectiveRowsPerPage,
                searchValue: oldPageDetail.search_value,
                searchKey: oldPageDetail.searchKey,
                claimsDropdownSelect: oldPageDetail.claimsDropdownSelect,
                labelValue: value.length ? value[0].value : '',
                formattedRuleDate: oldPageDetail.formattedRuleDate ? new Date(oldPageDetail.formattedRuleDate) : '',
                sortKey: oldPageDetail.sortKey || '',
                sortDirection: oldPageDetail.sortDirection || 'asc',
                isFilter: this.hasActiveFilter(restoredFilterData),
                showCheckedValues: this.hasActiveFilter(restoredFilterData),
                filterData: restoredFilterData || this.state.filterData,
                pages: restoredIsNotRan ? this.notRanPaginationOptions : this.reviewedPaginationOptions
            }, () => {
                this.deleteSpecificCache('navigateBack');
                this.refreshCurrentListData();
            });
        } else if (this.props.history.location.state && user?.roleId !== 9) {
            // Handle specific practice change from router state
            this.state.handlePracticeChangeByNotReviewPage({
                target: { value: this.props.history.location.state.practiceId },
                practiceData: this.props.history.location.state.practiceData,
            }, () => {
                this.setState({
                    claimsDropdownSelect: this.props.history.location.state.claimsDropdownSelect,
                    labelValue: "Worklist",
                    page: 0,
                    offset: 0
                }, () => this.refreshCurrentListData());
            });
        } else if (this.props?.history?.location?.state?.claimsDropdownSelect == "claimsNotReviewed" && user?.roleId == 9) {
            const practice = this.getStoredPractice();
            if (!practice?.id) {
                this.setState({
                    claimsDropdownSelect: 'claimsNotReviewed',
                    labelValue: 'Worklist',
                    page: 0,
                    offset: 0
                }, this.waitForPracticeAndLoad);
                return;
            }
            this.setState({
                practiceId1: practice.id,
                pmLinkedStatus: practice.PMLinkedStatus,
                claimsDropdownSelect: 'claimsNotReviewed',
                labelValue: 'Worklist',
                page: 0,
                offset: 0
            }, () => this.refreshCurrentListData());
        } else {
            this.setState({ claimsDropdownSelect: 'notRan' });
        }
    }

    // Don't forget to clean up!
    componentWillUnmount() {
        if (socket) {
            socket.off("trackRanEncounter");
            socket.off("checkAutoRun");
            socket.off("disconnect");
        }
        if (this.practiceWaitTimer) {
            clearInterval(this.practiceWaitTimer);
            this.practiceWaitTimer = null;
        }
    }

    // Re-run filter if props like `encounters` or `rulesDataCopy` change.
    // Add other dependencies as needed.
    componentDidUpdate(prevProps, prevState) {
        if (this.tableContainer && this.prevScrollTop !== undefined) {
            this.tableContainer.scrollTop = this.prevScrollTop;
        }
    }

    applySavedFilter = async () => {
        const storedFilterData = JSON.parse(localStorage.getItem('claimFilter'));
        if (!storedFilterData) return;
        const { encountersCopy, rulesDataCopy, claimsDropdownSelect } = this.state;
        const initialData = claimsDropdownSelect === 'notRan' ? encountersCopy : rulesDataCopy;
        const finalResult = await this.performFiltering(initialData, storedFilterData);
        // 🚫 Bail on failure
        if (finalResult?.failed) {
            return;
        }

        // 🚫 Bail on cleared
        if (finalResult?.cleared) {
            return;
        }
        // ✅ Ensure it's a valid array
        const safeResult = Array.isArray(finalResult) ? finalResult : [];
        const filterCount = safeResult?.map(item => item.EncounterID)

        this.setState(prevState => {
            const updatedState = {
                showCheckedValues: true,
                filterData: storedFilterData,
                isFilter: true,
                filterClaims: filterCount?.length
            };
            if (prevState.claimsDropdownSelect === 'notRan') {
                updatedState.encounters = safeResult;
            } else {
                updatedState.rulesData = safeResult;
            }
            return updatedState;
        });
    };

    formatDateToMMDDYYYY_UTC = (dateStr) => {
        const dateObj = new Date(dateStr);
        // Use UTC methods to ignore local timezone offset
        const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() is 0-indexed
        const day = String(dateObj.getUTCDate()).padStart(2, '0');
        const year = dateObj.getUTCFullYear();

        return `${month}/${day}/${year}`;
    };

    /** Worklist functions **/

    // function to get whats needed values
    getWhatsNeeded = async () => {
        let result = await API.get("/getClaimActions/claimScrubber")
        let whatsNeededItems = []
        result.data.forEach((item) => {
            whatsNeededItems.push({
                key: item.id,
                value: item.items
            })
        })
        this.setState({ whatsNeededCS: whatsNeededItems })
    }

    // function to get user list
getAssignedUsers = () => {
    API.get("/getAssignToUsers?tableType=rule-processor")
        .then((result) => {
            if (result.data.success === true && result.data.userList.length) {
                let userArr = ["Danish", "Monu", "Saurabh", "puneet"]
                let userList = result.data.userList.filter(item => !userArr.includes(item.first_name));
                this.setState({ assignTo: userList });
            }
        })
        .catch((error) => {
            NotificationManager.error(
                "Something Went wrong!",
                "Failure!",
                3000
            );
        });
};

    // function to handle checkbox selection
    handleCheckboxClick = (event, row = null) => {
        let incomingVal = event.target.value;
        const { name } = event.target;

        switch (name) {
            case "checkboxForAllRows":
                // Toggle the 'checkboxForAllRows' state and update details
                this.setState((prevState) => {
                    const isCheckingAll = incomingVal === 'false';
                    return {
                        checkboxForAllRows: !prevState.checkboxForAllRows,
                        updateWorklistDetails: {
                            ...prevState.updateWorklistDetails,
                            id: isCheckingAll ? row.map(eml => eml.instanceID) : [],
                            worklistRows: isCheckingAll ? [...row] : []
                        }
                    };
                });
                break;

            case "userCheckbox":
                incomingVal = +incomingVal;
                // Access denialListAllRows and updateWorklistDetails from state
                const { rulesData, updateWorklistDetails } = this.state;
                const targetInstanceID = row.instanceID;

                const encountersToSelect = (rulesData || []).filter(
                    item => item.instanceID === row.instanceID
                );
                const isAlreadySelected = updateWorklistDetails.id.includes(targetInstanceID);

                if (!isAlreadySelected) {
                    // --- SELECTION LOGIC ---
                    this.setState((prevState) => {
                        const prevRows = prevState.updateWorklistDetails.worklistRows || [];
                        const uniqueIds = [...new Set([...prevState.updateWorklistDetails.id, targetInstanceID])];

                        const allRows = [...prevRows, ...encountersToSelect];
                        const uniqueRowsMap = new Map(allRows.map(obj => [obj.id, obj]));

                        return {
                            updateWorklistDetails: {
                                ...prevState.updateWorklistDetails,
                                id: uniqueIds,
                                worklistRows: [...uniqueRowsMap.values()]
                            }
                        };
                    });
                } else {
                    // --- DESELECTION LOGIC ---
                    this.setState((prevState) => ({
                        updateWorklistDetails: {
                            ...prevState.updateWorklistDetails,
                            id: prevState.updateWorklistDetails.id.filter(id => id !== targetInstanceID),
                            worklistRows: prevState.updateWorklistDetails.worklistRows.filter(r => r.instanceID !== row.instanceID)
                        }
                    }));
                }
                break;

            case "worklistNote":
            case "WhatsNeeded":
                // Dynamic key update for Note or WhatsNeeded
                this.setState((prevState) => ({
                    updateWorklistDetails: {
                        ...prevState.updateWorklistDetails,
                        [name === "worklistNote" ? "Note" : "WhatsNeeded"]: incomingVal
                    }
                }));
                break;

            default:
                console.log("wrong key selection");
        }
    };

    resetState = (stateName) => {
        // Accessing the DOM via createRef() requires using .current
        const autoCautoCAssignRefEle = this.autoCAssignRef.current?.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
        if (autoCautoCAssignRefEle) {
            autoCautoCAssignRefEle.click();
        }

        // Common assignments for both branches
        this.assigntoHint = "";

        if (stateName === "resetButtonHandle") {
            this.setState((prevState) => ({
                assigntoValue: "",
                updateWorklistDetails: {
                    Note: '',
                    AssignedTo: "",
                    WhatsNeeded: "",
                    DueDate: "",
                    id: prevState.updateWorklistDetails.id, // Preserve id from previous state
                    worklistRows: []
                }
            }));
        }

        if (stateName === "updateWorklistDetails") {
            this.setState({
                checkboxForAllRows: false,
                assigntoValue: "",
                updateWorklistDetails: {
                    Note: '',
                    AssignedTo: "",
                    WhatsNeeded: "",
                    DueDate: "",
                    id: [],
                    worklistRows: []
                }
            });
        }
    };

    // function to handle note required pop up
    handleNoteRequired = () => {
        this.setState({ noteRequired: !this.state.noteRequired.visible })
    }

    // function to update worklist rows based on inputs
    updateWorklistRow = () => {
        const { updateWorklistDetails } = this.state;

        // 1. Check if at least one row is selected
        if (!updateWorklistDetails.id || updateWorklistDetails.id.length === 0) {
            NotificationManager.error(
                "Please select at least one row to continue!",
                "Failure!",
                3000
            );
            return;
        }

        // 2. Note validation - If empty, show the popup
        if (!updateWorklistDetails.Note || updateWorklistDetails.Note.trim().length === 0) {
            this.setState({
                noteRequired: {
                    tagName: 'note',
                    visible: true, // This triggers your popup component
                }
            });
            return;
        }

        // 3. Validation passed: execute update
        this.updateData();
    };

    updateData = () => {
        const { updateWorklistDetails } = this.state;

        // Construct payload with the 4 specific fields + id
        const payload = {
            id: updateWorklistDetails.id,
            Note: updateWorklistDetails.Note,
            AssignedTo: updateWorklistDetails.AssignedTo,
            WhatsNeeded: updateWorklistDetails.WhatsNeeded,
            DueDate: updateWorklistDetails.DueDate
        };

        API.put("/updateClaimData", payload).then((result) => {
            if (result.data && result.data.success === true) {
                NotificationManager.success(
                    "Rows updated successfully",
                    "Successful!",
                    2000
                );

                // Decrement counter if needed
                if (updateWorklistDetails.worklistRows) {
                    const uniqueEncounters = new Set(updateWorklistDetails.worklistRows.map(item => item.EncounterID)).size;
                    this.setState(prevState => ({
                        encCount: prevState.encCount - uniqueEncounters
                    }));
                }

                // Refresh worklist
                this.setState({ page: 0, offset: 0 }, () => this.refreshCurrentListData());

                // Reset form state
                this.resetState("updateWorklistDetails");
            }
        }).catch(error => {
            NotificationManager.error("Update failed", "Error");
            console.error(error);
        });
    };

    // function to mark selected rows as reviewed
    markRowsAsReviewed = () => {
        const { updateWorklistDetails, rulesData } = this.state;
        if (!updateWorklistDetails.id || updateWorklistDetails.id.length === 0) {
            NotificationManager.error(
                "Please select at least one row to continue!",
                "Failure!",
                2000
            );
            return;
        }
        // ✅ Save scroll position
        if (this.tableContainer) {
            this.prevScrollTop = this.tableContainer.scrollTop;
        }
        const body_data = {
            isReviewed: true,
            id: updateWorklistDetails.id
        }
        LoadingSpinner.show();
        API.post('updateReviewStatus', body_data).then((res) => {
            if (res.data.code === 200 && res.data.success === true) {
                const reviewedIds = updateWorklistDetails.id;
                const newRulesData = rulesData.filter(
                    item => !reviewedIds.includes(item.instanceID)
                );
                // ✅ Remove rows locally (NO full refresh)
                this.setState({
                    rulesData: newRulesData,
                    totalRows: (this.state.totalRows - (reviewedIds?.length)),
                    count_encounters: (this.state.count_encounters - (reviewedIds?.length)),
                    updateWorklistDetails: {
                        id: [],
                        worklistRows: []
                    }
                });
                LoadingSpinner.hide();
            }
        }).catch((error) => {
            console.error(error)
            LoadingSpinner.hide();
        });
    }

    // Toggles the modal visibility and initializes data
    handleNotePopup = () => {
        const { updateWorklistDetails, rulesData } = this.state;
        if (updateWorklistDetails.id.length === 0) {
            NotificationManager.error('Select at least one row', "Error", 2000);
        } else {
            const initialViewData = rulesData.find(item => item.instanceID === updateWorklistDetails.id[0]);
            this.setState({
                openNotePopup: true,
                viewHistoryPage: 0,
                viewHistoryData: initialViewData
            });
        }
    };

    // Generic navigation handler (Next/Previous)
    handleNavigation = (direction) => {
        const { viewHistoryPage, updateWorklistDetails, rulesData } = this.state;
        const newPage = direction === 'next' ? viewHistoryPage + 1 : viewHistoryPage - 1;
        const newData = rulesData.find(item => item.instanceID === updateWorklistDetails.id[newPage]);

        if (newData) {
            this.setState({ viewHistoryPage: newPage, viewHistoryData: newData });
        }
    };

    // Close handler for the modal
    handleClosePopup = () => this.setState({ openNotePopup: false });

    // function to handle assign back functionality
    assignBack = () => {
        const { updateWorklistDetails } = this.state;
        let body_data = {
            id: updateWorklistDetails.id,
            Note: updateWorklistDetails.Note,
            assignBack: true
        }
        API.post('/assignBackToUser', body_data).then(res => {
            this.setState({ page: 0, offset: 0 }, () => this.refreshCurrentListData());
            this.resetState("updateWorklistDetails");
        }).catch(err => {
            console.error(err)
        })
    }


    // function to export cliam scrubber worklist
    exportClaimWorklist = () => {
        let practice = JSON.parse(sessionStorage.getItem("practice"))
        let exportedExcelName;
        if (practice == "all") {
            exportedExcelName = "All Practices-Claim Scrubber-Worklist";
        } else {
            exportedExcelName = `${practice?.practiceAcronym}-Claim Scrubber-Worklist`;
        }

        const toExcelDateMidnightUTC = (formattedDate) => {
            if (!formattedDate) return null;

            let date;

            // Check if the date string includes time information (indicated by 'T' or a space)
            if (formattedDate.includes('T') || formattedDate.includes(' ')) {
                // If a time component exists, create a Date object and then zero out the time.
                date = new Date(formattedDate);
                if (isNaN(date.getTime())) {
                    console.error('Invalid date received:', formattedDate);
                    return null;
                }
                // Zero out the time components to get the start of the day in local time
                date.setHours(0, 0, 0, 0);

            } else {
                // For date-only strings (like "2025-09-21"), construct it manually
                // to ensure it is treated as local midnight, not UTC midnight.
                const [year, month, day] = formattedDate.split('-').map(Number);
                date = new Date(year, month - 1, day); // month is 0-indexed
            }

            // Handle invalid dates
            if (isNaN(date.getTime())) {
                console.error('Invalid date received:', formattedDate);
                return null;
            }

            // Create a new date at UTC midnight to perform the Excel number calculation
            // This is the most reliable way to prevent timezone shifts
            const utcMidnightMillis = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

            // Calculate the Excel date number based on the Excel epoch
            const excelEpoch = new Date(Date.UTC(1899, 11, 30));
            return (utcMidnightMillis - excelEpoch.getTime()) / (24 * 60 * 60 * 1000);
        };

        const exportColumns = [
            { key: "PracticeName" },
            // { key: "CustomerID", type: "integer" },
            // { key: "ClaimID", type: "integer" },
            { key: "EncounterID", type: "integer" },
            { key: "PatientID", type: "integer" },
            { key: "PatientName" },
            { key: "DOB", type: "date" },
            { key: "ServiceStartDate", type: "date" },
            // { key: "RenderingProviderID", type: "integer" },
            { key: "RenderingProviderName" },
            // { key: "SchedulingProviderID", type: "integer" },
            { key: "SchedulingProviderName" },
            { key: "ServiceLocationName" },
            { key: "InsPhone", type: "text" },
            { key: "PolicyNumber" },
            { key: "PrimaryInsurance" },
            { key: "PrimaryInsurancePolicyPlanID", type: "integer" },
            { key: "SecondaryInsurance" },
            { key: "SecondaryInsurancePolicyPlanID", type: "integer" },
            { key: "Code" },
            { key: "Mod" },
            { key: "DXC1" },
            { key: "TotalCharge", type: "decimal" },
            { key: "RuleViolations" },
            { key: "EligibilityActive" },
            { key: "Keyword(s) for Active Eligibility" },
            { key: "Keyword(s) to Violate Eligibility" },
            // { key: "Balance", type: "decimal" },
            // { key: "AdjCode" },
            // { key: "Remark" },
            // { key: "Advice" },
            // { key: "Issue Type" },
            // { key: "DenialDate", type: "date" },
            // { key: "PaymentID" },
            { key: "Status" },
            // { key: "Redenied" },
            { key: "AssignedTo" },
            { key: "WhatsNeeded" },
            { key: "DueDate", type: "date" },
            // { key: "ActionTaken" },
            // { key: "CompletedBy" },
            { key: "ScrubbedDate", type: "date" },
            // { key: "LastNote" },
            { key: "CreatedOn", type: "date" },
            { key: "UpdatedOn", type: "date" }
        ];

        const sanitizedData = this.state.rulesData.map(item => ({
            PracticeName: practice.practiceName,
            // CustomerID: Number(item.CUSTOMERID),
            // ClaimID: Number(item.CLAIMID),
            EncounterID: Number(item.EncounterID),
            PatientID: Number(item.PatientID),
            PatientName: item.PatientName,
            DOB: item.PatientDateOfBirth,
            ServiceStartDate: item.ServiceStartDate,
            // RenderingProviderID: Number(item.RENDERING_PROVIDER_ID),
            RenderingProviderName: item.RenderingProviderName,
            // SchedulingProviderID: Number(item.SCHEDULING_PROVIDER_ID),
            SchedulingProviderName: item.SchedulingProviderName,
            ServiceLocationName: item.ServiceLocationName,
            InsPhone: formatPhoneNumber(item.InsPhone),
            PolicyNumber: item.PrimaryInsurancePolicyNumber,
            PrimaryInsurance: item.PrimaryInsurancePlanName,
            PrimaryInsurancePolicyPlanID: item.PrimaryInsurancePolicyPlanID ? Number(item.PrimaryInsurancePolicyPlanID) : null,
            SecondaryInsurance: item.SecondaryInsurancePlanName,
            SecondaryInsurancePolicyPlanID: item.SecondaryInsurancePolicyPlanID ? Number(item.SecondaryInsurancePolicyPlanID) : null,
            Code: item.ProcedureCode,
            Mod: item.ProcedureModifier1,
            DXC1: item.EncounterDiagnosisID1,
            TotalCharge: Number(item.TotalCharges),
            RuleViolations: item.ViolRule?.map((rule) => `${rule.ruleName} (${rule.ruleId})`).join(", "),
            EligibilityActive: item.eligibilitySuccess == null ? "" : item.eligibilitySuccess == false ? "FALSE" : "TRUE",
            KeywordsForActive: Number(item.TotalCharges),
            KeywordsToViolate: Number(item.TotalCharges),
            // Balance: Number(item.Balance),
            // AdjCode: item.Adj_Code,
            // Remark: item.Remark,
            // Advice: item.ADVICE,
            // IssueType: item.issueType,
            // DenialDate: toExcelDateMidnightUTC(item.Denial_Date),
            // PaymentID: Number(item.PAYMENTID),
            Status: "Worklist",
            // Redenied: item.Redenied == false || item.Redenied == null ? "No" : "Yes",
            AssignedTo: item.AssignedTo,
            WhatsNeeded: item.WhatsNeeded,
            DueDate: toExcelDateMidnightUTC(item.DueDate),
            // ActionTaken: item.ActionTaken,
            // CompletedBy: item.CompletedBy,
            ScrubbedDate: toExcelDateMidnightUTC(item.created_at),
            // LastNote: item.Notes[0] != undefined ? item.Notes[0].NOTES : "",
            CreatedOn: toExcelDateMidnightUTC(item.created_at),
            UpdatedOn: toExcelDateMidnightUTC(item.updated_at),
        }))

        // Convert to array of arrays (values only, no headers)
        const dataOnly = sanitizedData.map(item =>
            exportColumns.map(col => item[col.key])
        );

        // Create a new empty worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([]);

        // 1. Add the header row starting at A1
        XLSX.utils.sheet_add_aoa(worksheet, [exportColumns.map(col => col.key)], { origin: "A1" });

        // 2. Add the data starting from A2 (after the header)
        XLSX.utils.sheet_add_aoa(worksheet, dataOnly, { origin: "A2" });

        // Apply styles
        exportColumns.forEach((col, colIndex) => {
            const colLetter = XLSX.utils.encode_col(colIndex);
            for (let rowIndex = 1; rowIndex <= sanitizedData.length + 1; rowIndex++) {
                const cellAddress = `${colLetter}${rowIndex}`;
                const cell = worksheet[cellAddress];
                if (cell) {
                    if (col.type === "integer") {
                        cell.s = { numFmt: "0" };
                    } else if (col.type === "decimal") {
                        cell.s = { numFmt: "0.00" };
                    } else if (col.type === "date") {
                        cell.s = { numFmt: "mm/dd/yyyy" };
                    }
                }
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Denial Worklist");
        XLSX.writeFile(workbook, `${exportedExcelName}.xlsx`, {
            Props: { Title: exportedExcelName }
        });
    };

    getInsuranceStatus(rules) {
        // Add null checks at the start to prevent errors
        if (!rules || !rules.PrimaryInsurancePlanName) return 'N/A';

        if (rules.eligibilitySuccess === true) return 'Active';

        const isLinked = rules.PrimaryInsuranceLinkedStatus === true;

        if (rules.eligibilitySuccess === false && isLinked) {
            if (rules.isBypassed) return 'Bypassed';
            if (rules.PrimaryInsurancePolicyNumber !== "") return 'Not Active';
        }

        return 'N/A';
    }


    render() {
        const { encounters, showRule, selectedValues, getLastRule, trizettoData, fromDate, toDate, filterDateType, fromDate1, toDate1, encounterCount,
            encounterData, sortData, rulesData, ruleSuccess, showChargesPopup, selectDateType, selectedColumn, encounterLength, eligibilityData, showCancelLoader,
            showRunningCharges, showCancelRunningCharges, showChargesTryAgain, showPopup, showCancelPopup, showRulesTryAgain, showLoader,
            providerType, showProviderPopUp, tabValue, isFilter, filterClaims, totalFilteredRecords, claimsDropdownSelect, whatsNeededCS,
            updateWorklistDetails, assignTo, checkboxForAllRows, noteRequired, openNotePopup, viewHistoryPage, viewHistoryData,
            remaining, total, completed, showCancellingMsg, timeElapsed } = this.state;

        const totalSelected = updateWorklistDetails.id.length;
        let practiceData = JSON.parse(sessionStorage.getItem("practice"));
        let client = JSON.parse(sessionStorage.getItem("clientDetail"));
        let role = JSON.parse(sessionStorage.getItem("userDetail"));

        let pmLinkedStatus = JSON.parse(sessionStorage.getItem('practice'))?.PMLinkedStatus;
        let autoRunRule = practiceData?.autoRunRules;
        const rule = getLastRule[0];
        const showStyle = {
            width: 58,
            height: 45,
            backgroundColor: '#5CB02C',
            lineHeight: '12px',
            cursor: 'pointer',
            position: 'fixed',
            top: 80,
            right: 0,
            zIndex: 3,
            borderTopLeftRadius: '9px',
            borderBottomLeftRadius: '9px'
        }
        const hideStyle = {
            width: 300,
            height: '100%',
            overflow: 'hidden',
            background: 'linear-gradient(196.38deg, #81C3D7 13.47%, #81C3D7 38.72%, #3A7CA5 92.18%)',
            border: '1px solid #878787',
            borderRadius: '9px',
            lineHeight: '12px',
            position: 'fixed',
            top: 75,
            right: 0,
            zIndex: 0,
            transition: 'all .3s ease'
        }
        const header = {
            backgroundColor: '#24476A',
            height: 110,
            width: '100%',
            marginLeft: 0,
            borderRadius: '9px 9px 0px 0px'
        }
        const styles = {
            content: {
                width: '100%',
                marginTop: !pmLinkedStatus ? '' : 118,
                // marginLeft: 88,
                // marginBottom: 80,
                marginTop: '1rem',
                // marginTop: '7rem',
                padding: '0rem 0rem 0rem 1.5rem',
                border: '0px !important',
                position: 'absolute'
            }
        }

        return (
            <section>
                <SideBar
                    refreshPractice={(method) => {
                        this.setState({ refreshPractice: method })
                    }}
                    customSetPractice={(customSetPractice) => {
                        this.setState({ customSetPractice: customSetPractice });
                    }}
                    handlePracticeChangeByNotReviewPage={(method) => this.setState({ handlePracticeChangeByNotReviewPage: method })}
                    // handlePracticeChangeByNotReviewPage={(method) => { this.handlePracticeChangeByNotReviewPage = method; }}
                    isNavigateFromDashborad={this.props.history.location?.state?.practiceId}
                    handleChangePractice={(selectedPractice) => {
                        this.handleAutoRunStatus(selectedPractice.id)
                        const shouldFetchNotRan = this.state.claimsDropdownSelect == "notRan";
                        this.setState({
                            rulesRan: true,
                            showPopup: false,
                            showCancelPopup: false,
                            showCancellingMsg: false,
                            timeElapsed: null,
                            completed: 0,
                            total: 0,
                            remaining: 0,
                            encounters: [],
                            encounterCount: 0,
                            practiceId1: selectedPractice.id,
                            autoRunRuleChecked: getDataFromSession(
                                this.SESSION_PRACTICE_KEY
                            )?.autoRunRules,
                            searchKey: "",
                            // claimsDropdownSelect: "",
                            formattedRuleDate: "",
                            offset: 0,
                            page: 0,
                            searchValue: "",
                            sortKey: "",
                            sortDirection: "asc",
                            isFilter: false,
                            rowsPerPage: shouldFetchNotRan ? 100 : this.state.rowsPerPage,
                            pages: shouldFetchNotRan ? this.notRanPaginationOptions : this.reviewedPaginationOptions
                        }, () => {
                            this.handlePMConnection();
                            if (shouldFetchNotRan) {
                                this.getEncounters(selectedPractice.id);
                            } else {
                                this.refreshCurrentListData();
                            }
                        });
                    }}
                    totalClaims={this.state.rulesRan ? encounterData : encounters}
                    totalFilteredClaims={rulesData}
                    ruleSuccess={this.state.ruleSuccess}
                    formattedRuleDate={this.state.formattedRuleDate}
                    date={this.state.date}
                    localDate={this.state.localDate}
                    onRunRules={() => this.runRules()}
                    rulesRan={this.state.rulesRan}
                    // getEncounters={this.getEncounters}
                    chargesFunc={(practiceId) => this.getCharges()}
                    getAutoRunRulesStatus={this.getAutoRunRulesStatus}
                    handleRuleProcesserButton={this.handleRuleProcesserButton}
                />

                {pmLinkedStatus === false && <div className='connection-banner'>
                    <p className='mt-3'>WE ARE HAVING TROUBLE CONNECTING TO YOUR THIRD PARTY SOFTWARE. PLEASE CHECK THE CONNECTION IN THE SETTINGS</p>
                </div>}



                <div className='section-layout' onClick={() => this.setState({ optionSelector: false })}>
                    <div className='claim-layout '>
                        <div className="row font-face-futura text-start">
                            <span className='font18'>Claim Scrubbing</span>
                        </div>
                        <div className="botDivider"></div>

                        {claimsDropdownSelect == 'claimsNotReviewed' && <div className="ruleout-grid mb-3">
                            <div>
                                <div className="font-face-futura text-start noteDiv">
                                    <span className="px-1">Note</span>
                                    <textarea
                                        placeholder="Write what was done to fix the claim..."
                                        className="p-2 denialNote w-100"
                                        name="worklistNote"
                                        value={updateWorklistDetails.Note}
                                        onChange={this.handleCheckboxClick}
                                    />
                                </div>
                            </div>
                            <div className="d-flex flex-column justify-content-center gap-3">
                                <div className={`ruleout-grid-three ${role?.roleId == 9 ? "external-user" : ""}`}>
                                    <div>
                                        <span className="denial-forminput">
                                            <label className="text-nowrap">{role?.roleId == 9 ? "Assign to Another External User:" : "Assigned To:"}</label>
                                            <Autocomplete
                                                className="justify-content-start autocomplete-select2"
                                                ref={this.autoCAssignRef}
                                                onKeyDown={(event) => {
                                                    if (event.key === "Tab") {
                                                        if (this.assigntoHint) {
                                                            const hintValue = this.assigntoHint;
                                                            this.setState((prevState) => ({
                                                                assigntoValue: hintValue,
                                                                updateWorklistDetails: {
                                                                    ...prevState.updateWorklistDetails,
                                                                    AssignedTo: hintValue,
                                                                },
                                                            }));
                                                            event.preventDefault();
                                                        }
                                                    }
                                                }}
                                                onClose={() => {
                                                    this.assigntoHint = "";
                                                }}
                                                onChange={(event, newValue) => {
                                                    const formattedName = newValue && newValue.id
                                                        ? `${newValue.first_name} ${newValue.last_name}`
                                                        : "";
                                                    const assignedId = newValue && newValue.id ? newValue.id : "";

                                                    this.setState((prevState) => ({
                                                        assigntoValue: formattedName,
                                                        updateWorklistDetails: {
                                                            ...prevState.updateWorklistDetails,
                                                            AssignedTo: assignedId,
                                                        },
                                                    }));
                                                }}
                                                blurOnSelect
                                                inputValue={this.state.assigntoValue}
                                                id="combo-box-hint-demo-"
                                                options={assignTo} // Assuming assignTo is in state
                                                getOptionLabel={(option) =>
                                                    option ? `${option.first_name} ${option.last_name}${option.roleid === 9 ? " (External User)" : ""}` : ""
                                                }
                                                renderInput={(params) => {
                                                    return (
                                                        <Box className="autocompleteselect2-container">
                                                            <TextField
                                                                className="autocompleteinput-container"
                                                                {...params}
                                                                onChange={(event) => {
                                                                    const newValue = event.target.value;

                                                                    // Update text state and details object
                                                                    this.setState((prevState) => ({
                                                                        assigntoValue: newValue,
                                                                        updateWorklistDetails: {
                                                                            ...prevState.updateWorklistDetails,
                                                                            AssignedTo: newValue,
                                                                        },
                                                                    }));

                                                                    // Logic for hint (replacing assigntoHint.current)
                                                                    const matchingOption = assignTo.find(
                                                                        (option) =>
                                                                            option.first_name.startsWith(newValue) ||
                                                                            option.last_name.startsWith(newValue)
                                                                    );

                                                                    if (newValue && matchingOption) {
                                                                        this.assigntoHint =
                                                                            matchingOption.first_name + " " + matchingOption.last_name;
                                                                    } else {
                                                                        this.assigntoHint = "";
                                                                    }
                                                                }}
                                                                placeholder="Select"
                                                            />
                                                        </Box>
                                                    );
                                                }}
                                            />
                                        </span>
                                    </div>
                                    {role?.roleId != 9 && <>
                                        <div>
                                            <span className="denial-forminput">
                                                <label className="text-nowrap">What's Needed</label>
                                                <select
                                                    name="WhatsNeeded"
                                                    value={updateWorklistDetails.WhatsNeeded}
                                                    onChange={(event) => this.handleCheckboxClick(event)}
                                                    className="denialSelect2"
                                                >
                                                    <option value="" disabled selected>
                                                        Select
                                                    </option>
                                                    {whatsNeededCS.map((item) => (
                                                        <option key={item.key} value={item.key}>
                                                            {item.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </span>
                                        </div>
                                        <div>
                                            <span className="denial-forminput">
                                                <label className="text-nowrap">Due Date</label>
                                                <DatePicker
                                                    className="denialSelect2"
                                                    format={"MM-dd-yyyy"}
                                                    placeholderText="MM/DD/YYYY"
                                                    name="DueDate"
                                                    selected={updateWorklistDetails.DueDate}
                                                    onChange={(date) => {
                                                        this.setState((prevState) => ({
                                                            updateWorklistDetails: {
                                                                ...prevState.updateWorklistDetails,
                                                                DueDate: date
                                                            }
                                                        }));
                                                    }} />
                                            </span>
                                        </div>
                                    </>}
                                </div>
                                <div className="denial-buttons gap-3 justify-content-end">
                                    <Button
                                        className="text-white resetBtn"
                                        variant="contained" onClick={this.handleNotePopup}>
                                        <span className="text-capitalize font-face-futura">
                                            View
                                        </span>
                                    </Button>
                                    <Button
                                        className="text-white resetBtn"
                                        onClick={() => this.resetState("resetButtonHandle")}
                                        variant="contained">
                                        <span className="text-capitalize font-face-futura">
                                            Reset
                                        </span>
                                    </Button>
                                    {role?.roleId != 9 ? <ButtonGroup>
                                        <Button
                                            className="text-white saveButn curvebtn"
                                            variant="contained"
                                            onClick={this.updateWorklistRow}
                                        >
                                            <span className="text-capitalize font-face-futura">
                                                Save
                                            </span>
                                        </Button>
                                        <Button
                                            className="savebtn-dropdown"
                                            size="small"
                                            // derive 'open' state by checking if anchorEl exists
                                            aria-controls={this.state.anchorEl ? 'split-button-menu' : undefined}
                                            aria-expanded={this.state.anchorEl ? 'true' : undefined}
                                            aria-haspopup="true"
                                            onClick={(e) => {
                                                // event.currentTarget is the standard for positioning the menu
                                                this.setState({ anchorEl: e.currentTarget });
                                            }}>
                                            <ArrowDropDownIcon style={{ visibility: 'visible' }} />
                                        </Button>
                                        <Menu
                                            id="split-button-menu"
                                            className="savebtn-modal claimbtn-modal"
                                            anchorEl={this.state.anchorEl}
                                            keepMounted
                                            // Open is true if anchorEl is not null
                                            open={Boolean(this.state.anchorEl)}
                                            onClose={() => this.setState({ anchorEl: null })}>
                                            <MenuItem onClick={() => {
                                                this.markRowsAsReviewed();
                                                this.setState({ anchorEl: null }); // You must close it here!
                                            }}>
                                                Mark as Reviewed
                                            </MenuItem>
                                        </Menu>
                                    </ButtonGroup> :
                                        <Button
                                            className="text-white saveBtn"
                                            variant="contained"
                                            onClick={this.updateWorklistRow}
                                        >
                                            <span className="text-capitalize font-face-futura">
                                                Save
                                            </span>
                                        </Button>}
                                    {role?.roleId == 9 && <Button
                                        className="text-white assignBtn"
                                        variant="contained"
                                        onClick={this.assignBack}
                                    >
                                        <span className="text-capitalize font-face-futura">
                                            Assign Back
                                        </span>
                                    </Button>}
                                </div>
                            </div>
                            {noteRequired.visible && (
                                <Dialog
                                    fullWidth
                                    open={noteRequired.visible}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <div align="center" className="avatar3">
                                        <CancelIcon
                                            className="dialogCancel"
                                            fontSize="large"
                                        />
                                    </div>
                                    <div
                                        align="center"
                                        className="dialog-box3 dialog-box-denail"
                                    >
                                        <DialogTitle id="alert-dialog-title">
                                            <span className="font-face-futura dialogTitle dialogTitlefontSize">
                                                {(noteRequired.tagName || "").toUpperCase()}{" "}
                                                REQUIRED
                                            </span>
                                        </DialogTitle>
                                        <DialogContent>
                                            <DialogContentText id="alert-dialog-description ">
                                                <span className="font-face-futura dialogText">
                                                    A {noteRequired.tagName} is required before
                                                    changing this claim's status
                                                </span>
                                            </DialogContentText>
                                            <Button
                                                fullWidth
                                                className="mt-4 dialogBtn"
                                                variant="contained"
                                                onClick={this.handleNoteRequired}
                                            >
                                                <span className="font-face-futura">GO BACK</span>
                                            </Button>
                                        </DialogContent>
                                    </div>
                                </Dialog>
                            )}
                            <ClaimNoteHistory
                                openNote={openNotePopup}
                                // The close handler needs to be distinct from the open handler
                                closeNotePopup={this.handleClosePopup}
                                firstPage={viewHistoryPage}
                                totalPage={totalSelected}
                                // Bind the specific actions to the generic handler
                                clickNext={() => this.handleNavigation('next')}
                                clickPrevious={() => this.handleNavigation('previous')}
                                viewData={viewHistoryData}
                            />
                        </div>}
                    </div>

                    <div ref={(el) => (this.tableContainer = el)}
                        className={`table-responsive denial-style custom-size w-100 tableresponsivecustom ${showRule ? "opentoggle1" : ""} ${ruleSuccess ? "claim-scrubbing2" : "claim-table"} ${claimsDropdownSelect == "claimsNotReviewed" ? "" : "claimscompleted"}`}>{ }
                        <table className="denial-table">
                            <thead>
                                <tr>
                                    <th className="text-center py-2">{claimsDropdownSelect == "claimsNotReviewed" ?
                                        <span type="button">
                                            <RoCheckbox
                                                name="checkboxForAllRows"
                                                value={checkboxForAllRows}
                                                checked={checkboxForAllRows}
                                                onChange={(e) => {
                                                    this.handleCheckboxClick(e, rulesData)
                                                }} />
                                        </span> : <></>}</th>
                                    {(ruleSuccess === true || role?.roleId == 9 ? columnHeader2 : columnHeader).map((col, index) => (
                                        <th className='text-center py-2' key={index} >
                                            <span>
                                                <span
                                                    type="button"
                                                    style={{
                                                        cursor: 'pointer',
                                                        color: this.state.sortKey === col.key ? '#5CB02C' : undefined
                                                    }}
                                                    onClick={() => this.onSort(col.key)}
                                                >
                                                    {(providerType === 'Scheduling' && col.name === 'Provider') ? 'Scheduling Provider' :
                                                        (providerType === 'Rendering' && col.name === 'Provider') ? 'Rendering Provider' : col.name}
                                                    {this.state.sortKey === col.key &&
                                                        <ArrowDropDownIcon
                                                            style={{
                                                                fontSize: 16,
                                                                verticalAlign: 'middle',
                                                                marginLeft: 4,
                                                                transform: this.state.sortDirection === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)'
                                                            }}
                                                        />
                                                    }
                                                </span>
                                            </span>
                                        </th>
                                    ))}
                                    {ruleSuccess === true ?
                                        <>
                                            {/* <th className="text-center py-2">
                                                <span type="button">Scrub Date</span>
                                            </th> */}
                                            {this.state.claimsDropdownSelect == "claimsReviewed" &&
                                                <th className="text-center py-2">
                                                    <span type="button">Date Completed</span>
                                                </th>}
                                            <th className="text-center py-2">
                                                <span type="button">Actions</span>
                                            </th>
                                        </> : <></>}
                                </tr>
                            </thead>
                            {!this.state.enableAutoRunRuleSetting && <tbody>
                                {showPopup || showCancelPopup ?
                                    <div align="center" className={showCancelPopup ? 'new-avatar2' : 'new-avatar'}>
                                        <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                                        <Loader className="mt-2" type='Oval'
                                            height={180}
                                            width={195}
                                            color="#5CB02C"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#5CB02C"
                                            strokeWidth={2}
                                            strokeWidthSecondary={2} />
                                        <span className='font-face-futura dialogTitle'>{"Running Encounters"}</span><br />
                                        {showCancelPopup ?
                                            <>
                                                <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                                <span className='dialogText'>Give us a little bit longer</span>
                                                <div>
                                                    <div style={{ color: '#5CB02C', margin: '10px 0' }}>
                                                        <div>Running {completed} of {total} encounters</div>
                                                        <div>Remaining: {remaining}</div>
                                                        <div>Time elapsed: {timeElapsed}...</div>
                                                    </div>
                                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={this.handleCancelRunRule}>
                                                        <span className='font-face-futura'>Cancel</span>
                                                    </Button>
                                                </div>
                                            </> :
                                            <>
                                                <div style={{ color: '#5CB02C', margin: '10px 0' }}>
                                                    <div>Running {completed} of {total} encounters</div>
                                                    <div>Remaining: {remaining}</div>
                                                    <div>Time elapsed: {timeElapsed}...</div>
                                                </div>
                                                <span className='font-face-futura dialogText'>
                                                    {!showCancellingMsg ? "Hold tight while we scrub these claims!" : <>
                                                        <span className='dialogText'>Almost there!</span><br />
                                                        <span className='dialogText'>Finishing the last claim—this will close in a moment.</span>
                                                    </>}</span>
                                            </>
                                        }
                                    </div> :
                                    showRulesTryAgain ?
                                        <div align="center" className='new-avatar2'>
                                            <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                                            <Loader className="mt-2" type='Oval'
                                                height={180}
                                                width={195}
                                                color="#5CB02C"
                                                wrapperStyle={{}}
                                                wrapperClass=""
                                                visible={true}
                                                ariaLabel='oval-loading'
                                                secondaryColor="#5CB02C"
                                                strokeWidth={2}
                                                strokeWidthSecondary={2} />
                                            <span className='font-face-futura dialogTitle'>{"UH, OH!"}</span><br />
                                            <>
                                                <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                                <span className='dialogText'>Give us a little bit longer</span>
                                                <div>
                                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                                        <span className='font-face-futura'>THAT'S OKAY</span>
                                                    </Button>
                                                </div>
                                            </>
                                        </div> :
                                        ruleSuccess !== true ? encounters?.length > 0 ? encounters?.map((encounter, index) => {
                                            let patientName = encounter.PatientName;
                                            patientName = patientName.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let SproviderName = encounter?.SchedulingProviderName;
                                            SproviderName = SproviderName?.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let RproviderName = encounter?.RenderingProviderName;
                                            RproviderName = RproviderName?.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let primary = encounter.PrimaryInsurancePlanName;
                                            primary = primary.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let secondary = encounter.SecondaryInsurancePlanName;
                                            secondary = secondary.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let location = encounter.ServiceLocationName;
                                            location = location.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            return (
                                                <tr style={{ cursor: 'pointer' }} key={index} className={selectedValues.includes(encounter.EncounterID) ? "table-row active-tablerow" : "table-row"}>
                                                    <td>
                                                        <div className='innerdata'>
                                                            <RoCheckbox
                                                                style={{ width: 18, height: 18 }}
                                                                value={encounter.EncounterID}
                                                                checked={selectedValues.includes(encounter.EncounterID)}
                                                                onChange={this.handleSingleSelect}
                                                                disabled={!selectedValues.includes(encounter.EncounterID) && selectedValues.length > 29}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>
                                                            <span title={encounter.PatientName} className='deal-content'>{patientName}</span>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>{encounter.EncounterID}</div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>
                                                            <div>
                                                                <p title={providerType === 'Scheduling' ? encounter?.SchedulingProviderName : encounter?.RenderingProviderName}
                                                                    className='deal-content'>
                                                                    {providerType === 'Scheduling' ? SproviderName : RproviderName}
                                                                </p>
                                                                <p style={{ textDecoration: 'none', color: (encounter.RenderingProviderStatus === false || encounter.RenderingProviderStatus === null) && '#954437' }}>
                                                                    {(client.defaultChargePerProvider == true && (encounter.RenderingProviderStatus === false || encounter.RenderingProviderStatus === null)) && 'Rendering Not Active'}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>{encounter.ServiceStartDate}</div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>{encounter.ProcedureCode}</div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => { this.handleCell(encounter.EncounterID, encounter.PrimaryInsuranceLinkedStatus); localStorage.setItem("isPrimary", true) }}>
                                                        <div className='innerdata'>
                                                            <div>
                                                                <p title={encounter.PrimaryInsurancePlanName} className='deal-content'>{primary}</p>
                                                                <p style={{ textDecoration: 'none', color: encounter.PrimaryInsuranceLinkedStatus === true ? '#5CB02C' : '#954437' }}>
                                                                    {encounter.PrimaryInsuranceLinkedStatus === true ? 'EDI Linked' : encounter.PrimaryInsurancePlanName ? 'EDI Not Linked' : ''}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        <div className='innerdata'>
                                                            <div>
                                                                <p title={encounter.SecondaryInsurancePlanName} className='deal-content'>{secondary}</p>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata'>
                                                            <span title={encounter.ServiceLocationName} className='deal-content'>{location}</span>
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'center' }} onClick={(id) => this.handleRow(encounter.EncounterID)}>
                                                        <div className='innerdata' style={{ marginRight: '0rem', borderRadius: '0px 9px 9px 0px' }}>{encounter.EncounterDiagnosisID1}</div>
                                                    </td>
                                                </tr>
                                            )
                                        }) : (<tr><td colSpan={6} className="mt-3 noRecord text-center">No records found!</td></tr>) : rulesData?.length > 0 ? rulesData?.map((rules, idx) => {
                                            let patientName = rules.PatientName;
                                            patientName = patientName.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let providerName = client.providerType === 'Scheduling' ? rules.SchedulingProviderName : rules.RenderingProviderName;
                                            providerName = providerName.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let primary = rules.PrimaryInsurancePlanName;
                                            primary = primary.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let secondary = rules.SecondaryInsurancePlanName;
                                            secondary = secondary.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            let location = rules.ServiceLocationName;
                                            location = location.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                                                return letter.toUpperCase();
                                            });
                                            return (
                                                <tr style={{ cursor: 'pointer' }} id={`row-${rules.instanceID}`} key={`${rules.instanceID}-${rules.id}`} className="table-row">
                                                    <td className="text-center">
                                                        <div className='innerdata'>
                                                            {claimsDropdownSelect == "claimsReviewed" && <IconButton>
                                                                {rules?.runEligibilityForPrimary === true ?
                                                                    <>{rules?.isPassed === true ?
                                                                        <CheckCircleIcon fontSize="large" style={{ color: '#5CB02C' }} /> :
                                                                        <CancelIcon fontSize="large" style={{ color: '#954437' }} />}
                                                                    </> :
                                                                    <>{rules?.isPassed === true ?
                                                                        <CheckCircleIcon fontSize="large" style={{ color: '#5CB02C' }} /> :
                                                                        <CancelIcon fontSize="large" style={{ color: '#954437' }} />}
                                                                    </>
                                                                }
                                                            </IconButton>}
                                                            {claimsDropdownSelect == "claimsNotReviewed" && <RoCheckbox
                                                                name="userCheckbox"
                                                                value={rules.instanceID}
                                                                onChange={(e) => this.handleCheckboxClick(e, rules)}
                                                                checked={updateWorklistDetails.id.includes(rules.instanceID)}
                                                            />}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className='innerdata cstm-tooltip-container'>
                                                            <div className="custom-toltip">
                                                                {rules.ViolRule?.length || 0}
                                                                {rules.ViolRule?.length > 0 && <div className="tooltip-text">
                                                                    {/* Map through each rule to create a new line per violation */}
                                                                    {rules.ViolRule.map((item, ruleIdx) => (
                                                                        <div key={ruleIdx}>
                                                                            <span>{`Viol ${ruleIdx + 1}: `}</span>
                                                                            <span>{item.ruleName}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"><div className='innerdata'>{rules.EncounterID}</div></td>
                                                    <td className="text-center">
                                                        <div className='innerdata'>
                                                            <span title={rules.PatientName} className='deal-content'>{patientName}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"><div className='innerdata'>{rules.ServiceStartDate}</div></td>
                                                    <td className="text-center">
                                                        <div className='innerdata'>
                                                            <span title={client.providerType === 'Scheduling' ? rules.SchedulingProviderName : rules.RenderingProviderName}
                                                                className='deal-content'>{providerName}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className='innerdata'>
                                                            <span title={rules.ServiceLocationName} className='deal-content'>{location}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"
                                                    // onClick={(id) => { this.handleCell(rules.instanceID); localStorage.setItem("isPrimary", true) }}
                                                    >
                                                        <div className='innerdata'>
                                                            <div>
                                                                <p title={rules.PrimaryInsurancePlanName} className='deal-content'>{primary}</p>
                                                                <p style={{ textDecoration: 'none', color: rules?.eligibilitySuccess === true ? '#5CB02C' : '#954437' }}>
                                                                    {this.getInsuranceStatus(rules)}
                                                                    {/* {rules.PrimaryInsurancePlanName && rules?.eligibilitySuccess === true ? 'Active' :
                                                                (rules.PrimaryInsurancePlanName && rules?.eligibilitySuccess === false && rules?.PrimaryInsuranceLinkedStatus === true && rules?.isBypassed) ? 'Bypassed' :
                                                                    (rules.PrimaryInsurancePlanName && rules?.eligibilitySuccess === false && rules?.PrimaryInsuranceLinkedStatus === true && rules?.PrimaryInsurancePolicyNumber !== "") ? 'Not Active' : 'N/A'} */}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td className="text-center">
                                                        <div className='innerdata'>
                                                            <div>
                                                                <p title={rules.SecondaryInsurancePlanName} className='deal-content'>{secondary}</p>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="text-center"><div className='innerdata'>{rules.ProcedureCode}</div></td>
                                                    <td className="text-center"><div className='innerdata'>{rules.ProcedureModifier1}</div></td>

                                                    <td className="text-center"><div className='innerdata'>{rules.EncounterDiagnosisID1}</div></td>
                                                    <td className="text-center"><div className='innerdata'>{rules.TotalCharges !== ""
                                                        ? Number(parseFloat(rules.TotalCharges).toFixed(2)).toString()
                                                        : rules.TotalCharges}</div></td>
                                                    <td className="text-center"><div className='innerdata text-wrap'>{rules.AssignedTo}</div></td>
                                                    <td className="text-center"><div className='innerdata'>{rules.WhatsNeeded}</div></td>
                                                    <td className="text-center">
                                                        <div className='innerdata' style={{ borderRadius: '0 9px 9px 0', marginRight: '-10px' }}>
                                                            <span title={new Date(rules?.created_at).toLocaleString('en-US')} className='deal-content'>{this.formatDateToMMDDYYYY_UTC(rules?.created_at)}</span>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className='innerdata' style={{ borderRadius: '0 9px 9px 0', marginRight: '-10px' }}>
                                                            <span title={new Date(rules?.DueDate).toLocaleString('en-US')} className='deal-content'>{this.formatDateToMMDDYYYY_UTC(rules?.DueDate)}</span>
                                                        </div>
                                                    </td>
                                                    {this.state.claimsDropdownSelect == "claimsReviewed" && <td className="text-center">
                                                        <div className='innerdata' style={{ borderRadius: '0 9px 9px 0', marginRight: '-10px' }}>
                                                            <span title={new Date(rules?.updated_at).toLocaleDateString('en-US')} className='deal-content'>{this.formatDateToMMDDYYYY_UTC(rules?.updated_at)}</span>
                                                        </div>
                                                    </td>}
                                                    <td className="text-center" onClick={(id) => this.handleRow(rules.instanceID, rules.EncounterProcedureID)}>
                                                        <div className='innerdata'>
                                                            <img
                                                                src={openInNew}
                                                                alt="open"
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }) : (<tr><td colSpan={6} className="mt-3 noRecord text-center">No records found!</td></tr>)}
                            </tbody>}
                            {this.state.enableAutoRunRuleSetting &&
                                <tbody>
                                    <div align="center" className='new-avatar'>
                                        <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                                        <Loader className="mt-2" type='Oval'
                                            height={180}
                                            width={195}
                                            color="#5CB02C"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                            visible={true}
                                            ariaLabel='oval-loading'
                                            secondaryColor="#5CB02C"
                                            strokeWidth={2}
                                            strokeWidthSecondary={2} />
                                        <span className='font-face-futura dialogTitle'>{"Auto-Run is Processing"}</span><br />
                                        <span className='dialogText'>Hold tight while we scrub your claims!</span>
                                    </div>
                                </tbody>
                            }
                        </table>

                        <div className={showRule ? 'rule-footer opentoggle2' : 'rule-footer'}>
                            <div className='foot-flex'>
                                <div className='foot-left flex-row align-items-center'>
                                    {ruleSuccess ?
                                        <>
                                            <div className='d-flex flex-column align-items-baseline'>
                                                {isFilter && <div className='encounter_count'>
                                                    <span>Filtered Encounters: {this.state?.filter_count}</span>
                                                </div>}
                                                <div className='encounter_count'>
                                                    <span>Total Encounters: {this.state?.count_encounters}</span>
                                                </div>
                                            </div>
                                            {claimsDropdownSelect == "claimsNotReviewed" &&
                                                <IconButton className="export-container">
                                                    <div className='export-btn align-items-center ms-2'>
                                                        <input
                                                            type="image"
                                                            src={exportIcon}
                                                            alt="exportDenial"
                                                            className="mx-1 claim-exporticon"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.exportClaimWorklist()}
                                                        />
                                                        <span className='export'>Export</span>
                                                    </div>
                                                </IconButton>
                                            }
                                        </> :
                                        <>
                                            <Button
                                                variant="contained"
                                                disabled={(pmLinkedStatus === false || this.state.showPopup || this.state.showCancelPopup) ? true : false}
                                                className="text-white p-2 text-capitalize runSelected"
                                                onClick={() => client?.defaultChargePerProvider === true ? this.handleRunRules() : this.runRules()}>
                                                <span className='font-face-futura' style={{ fontSize: 14 }}>Run Selected</span>
                                            </Button>

                                            <div class="round-check">
                                                <input
                                                    type="checkbox"
                                                    id="check-round"
                                                    disabled={pmLinkedStatus === false ? true : false}
                                                    checked={autoRunRule && JSON.parse(sessionStorage.getItem('practice'))?.PMLinkedStatus === true ? true : false}
                                                    onClick={async () => await this.updatePractice(!autoRunRule)} />
                                                <label for="check-round"></label>
                                                <span className='text-dark font-face-futura dlock'>Auto-run Rules</span>
                                            </div>
                                        </>}

                                </div>
                                <div className={`foot-right`}>
                                    {/* <div style={{ marginLeft: ruleSuccess || this.state.claimsDropdownSelect === 'ranByDay' ? '0px' : '110px' }}> */}
                                    <div style={{ marginLeft: ruleSuccess ? '0px' : '110px' }}>
                                        {/* {ruleSuccess || this.state.claimsDropdownSelect === 'ranByDay' ? <></> : <div> */}
                                        {ruleSuccess ? <></> : <div>
                                            {localStorage.getItem("refreshState") === true ?
                                                <p className="text-dark">Refreshing...</p> :
                                                <a
                                                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        if (!(this.state.showPopup || this.state.showCancelPopup)) {
                                                            this.OpenChargesPopup();
                                                        }
                                                    }}>
                                                    <img src={refresh} alt="logo" width={45} style={{ height: 50, float: 'left', marginRight: '20px', marginTop: 10 }} /></a>
                                            }
                                        </div>}
                                        {/* {ruleSuccess || this.state.claimsDropdownSelect === 'ranByDay' ? */}
                                        {ruleSuccess ?
                                            <div>
                                                <TablePagination
                                                    className={`pendingtable-pagination`}
                                                    rowsPerPageOptions={this.state.pages}
                                                    component="div"
                                                    count={(isFilter && this.state.claimsDropdownSelect != "notRan") ? totalFilteredRecords : this.state.totalRows}
                                                    rowsPerPage={this.state.rowsPerPage}
                                                    page={this.state.page}
                                                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                                                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                                                    onPageChange={this.handlePaginationData}
                                                    onRowsPerPageChange={(e) => this.onRowsPerPage(e)}
                                                />
                                            </div> :
                                            <span className="text-dark font-face-futura">
                                                <span className='fontw'>
                                                    Total Rows: {isFilter ? filterClaims : this.state.searchValue === '' ? encounterCount : encounterLength} </span><br />
                                                <span className='dateFont'>{practiceData?.filterDateType === 'createdDate' ? 'Created' : 'Serviced'}{' '}
                                                    <b>From:</b> {practiceData?.fromDate}{' '}
                                                    <b>To:</b> {practiceData?.toDate}
                                                </span><br />
                                                <span className='dateFont'>Last Updated: {new Date(practiceData?.lastUpdatedDate).toLocaleString('en-US')}</span>
                                            </span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {role?.roleId != 9 && <div>
                        <Box>
                            {showRule ? (
                                <div style={hideStyle}>
                                    <header className="row text-white font-face-futura" style={header}>
                                        <div className="col-10 mt-2">
                                            <h5 className="mostR">MOST<br />RECENT RULE</h5>
                                            <small className='small-label font-face-futura'>See what you created with us last to help test it with your current work list</small>
                                        </div>

                                        <div className="col-2" style={{ cursor: 'pointer' }} onClick={this.handleHide}>
                                            <RemoveRedEyeIcon className="mt-2" /><br />
                                            <span style={{ fontSize: 12 }}>Hide</span>
                                        </div>
                                    </header>
                                    <div className="font-face-futura ruleStyle">
                                        <h6 className="m-1" style={{ fontSize: 18 }}>Rule Name
                                            <div className="mt-1" style={{ width: 85, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1 mb-2" style={{ fontSize: 14 }}>{rule?.ruleName}</p>
                                        <div className="bottomDivider"></div>

                                        <div className='rule-box1'>
                                            <h6 className="m-1" style={{ fontSize: 18 }}>Rule
                                                <div className="mt-1" style={{ width: 32, borderBottom: '1px solid #0080A8' }}></div></h6>
                                            <p className="mt-2 mx-1" style={{ fontSize: 14, lineHeight: 1.5 }}>
                                                <span>{rule ? 'When the' : ''}</span> {' '}
                                                {rule?.ruleInfo.map((item, idx) => {
                                                    let finalValues = (item.condition === 'is' || item.condition === 'contains') ? (item.values.map(val => val.name ? val.name : val)).join(' or ') : (item.values.map(val => val.name ? val.name : val)).join(' and ');
                                                    return <span>{(idx > 0 ? ' the ' + item.category : item.category) + ' ' + item.condition + ' ' + finalValues + ' ' + (item.operator).toLowerCase()}
                                                    </span>
                                                })} {rule?.result}<span>{rule ? '.' : ''}</span>
                                            </p>
                                            <div className="bottomDivider"></div>

                                            <h6 className="m-1" style={{ fontSize: 18 }}>Reason
                                                <div className="mt-1" style={{ width: 55, borderBottom: '1px solid #0080A8' }}></div></h6>
                                            <p className="mt-2 mx-1" style={{ fontSize: 14 }}>{rule?.Reason}<span>{rule ? '.' : ''}</span></p>
                                            <div className="bottomDivider"></div>
                                        </div>

                                        <h6 className="m-1" style={{ fontSize: 18 }}>Info
                                            <div className="mt-1" style={{ width: 28, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Tags:</strong> {rule?.tags.length > 0 && (rule.tags).join(', ')}</p>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created On:</strong> {(new Date(rule?.created_at)).toLocaleDateString()}</p>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created By:</strong> Loren Dilger</p>
                                        <div className="bottomDivider"></div>

                                        <div align="center" className="mrtop-55">
                                            <Button className="text-white ruleBtn" variant="contained" onClick={(id) => this.editLastRule(rule?.ruleId)}>
                                                <span className='font-face-futura'>Edit</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-white" style={showStyle} onClick={this.handleShow}>
                                    <VisibilityOffIcon className="mt-1" /><br />
                                    <span className='font-face-futura' style={{ fontSize: 12 }}>Last Rule</span>
                                </div>
                            )}
                        </Box>
                    </div>}
                    {/* <div>
                        <Box>
                            {showRule ? (
                                <div style={hideStyle}>
                                    <header className="row text-white font-face-futura" style={header}>
                                        <div className="col-10 mt-2">
                                            <h5 className="mostR">MOST<br />RECENT RULE</h5>
                                            <small className='small-label font-face-futura'>See what you created with us last to help test it with your current work list</small>
                                        </div>

                                        <div className="col-2" style={{ cursor: 'pointer' }} onClick={this.handleHide}>
                                            <RemoveRedEyeIcon className="mt-2" /><br />
                                            <span style={{ fontSize: 12 }}>Hide</span>
                                        </div>
                                    </header>
                                    <div className="font-face-futura ruleStyle">
                                        <h6 className="m-1" style={{ fontSize: 18 }}>Rule Name
                                            <div className="mt-1" style={{ width: 85, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1 mb-2" style={{ fontSize: 14 }}>{rule?.ruleName}</p>
                                        <div className="bottomDivider"></div>

                                        <div className='rule-box1'>
                                            <h6 className="m-1" style={{ fontSize: 18 }}>Rule
                                                <div className="mt-1" style={{ width: 32, borderBottom: '1px solid #0080A8' }}></div></h6>
                                            <p className="mt-2 mx-1" style={{ fontSize: 14, lineHeight: 1.5 }}>
                                                <span>{rule ? 'When the' : ''}</span> {' '}
                                                {rule?.ruleInfo.map((item, idx) => {
                                                    let finalValues = (item.condition === 'is' || item.condition === 'contains') ? (item.values.map(val => val.name ? val.name : val)).join(' or ') : (item.values.map(val => val.name ? val.name : val)).join(' and ');
                                                    return <span>{(idx > 0 ? ' the ' + item.category : item.category) + ' ' + item.condition + ' ' + finalValues + ' ' + (item.operator).toLowerCase()}
                                                    </span>
                                                })} {rule?.result}<span>{rule ? '.' : ''}</span>
                                            </p>
                                            <div className="bottomDivider"></div>

                                            <h6 className="m-1" style={{ fontSize: 18 }}>Reason
                                                <div className="mt-1" style={{ width: 55, borderBottom: '1px solid #0080A8' }}></div></h6>
                                            <p className="mt-2 mx-1" style={{ fontSize: 14 }}>{rule?.Reason}<span>{rule ? '.' : ''}</span></p>
                                            <div className="bottomDivider"></div>
                                        </div>

                                        <h6 className="m-1" style={{ fontSize: 18 }}>Info
                                            <div className="mt-1" style={{ width: 28, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Tags:</strong> {rule?.tags.length > 0 && (rule.tags).join(', ')}</p>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created On:</strong> {(new Date(rule?.created_at)).toLocaleDateString()}</p>
                                        <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created By:</strong> Loren Dilger</p>
                                        <div className="bottomDivider"></div>

                                        <div align="center" className="mrtop-55">
                                            <Button className="text-white ruleBtn" variant="contained" onClick={(id) => this.editLastRule(rule?.ruleId)}>
                                                <span className='font-face-futura'>Edit</span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-white" style={showStyle} onClick={this.handleShow}>
                                    <VisibilityOffIcon className="mt-2" /><br />
                                    <span className='font-face-futura' style={{ fontSize: 12 }}>Last Rule</span>
                                </div>
                            )}
                        </Box>
                    </div> */}
                </div>

                {/* {tabValue === 0 && <div>
                    <Box>
                        {showRule ? (
                            <div style={hideStyle}>
                                <header className="row text-white font-face-futura" style={header}>
                                    <div className="col-10 mt-2">
                                        <h5 className="mostR">MOST<br />RECENT RULE</h5>
                                        <small className='small-label font-face-futura'>See what you created with us last to help test it with your current work list</small>
                                    </div>

                                    <div className="col-2" style={{ cursor: 'pointer' }} onClick={this.handleHide}>
                                        <RemoveRedEyeIcon className="mt-2" /><br />
                                        <span style={{ fontSize: 12 }}>Hide</span>
                                    </div>
                                </header>
                                <div className="font-face-futura ruleStyle">
                                    <h6 className="m-1" style={{ fontSize: 18 }}>Rule Name
                                        <div className="mt-1" style={{ width: 85, borderBottom: '1px solid #0080A8' }}></div></h6>
                                    <p className="mt-2 mx-1 mb-2" style={{ fontSize: 14 }}>{rule?.ruleName}</p>
                                    <div className="bottomDivider"></div>

                                    <div className='rule-box1'>
                                        <h6 className="m-1" style={{ fontSize: 18 }}>Rule
                                            <div className="mt-1" style={{ width: 32, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1" style={{ fontSize: 14, lineHeight: 1.5 }}>
                                            <span>{rule ? 'When the' : ''}</span> {' '}
                                            {rule?.ruleInfo.map((item, idx) => {
                                                let finalValues = (item.condition === 'is' || item.condition === 'contains') ? (item.values.map(val => val.name ? val.name : val)).join(' or ') : (item.values.map(val => val.name ? val.name : val)).join(' and ');
                                                return <span>{(idx > 0 ? ' the ' + item.category : item.category) + ' ' + item.condition + ' ' + finalValues + ' ' + (item.operator).toLowerCase()}
                                                </span>
                                            })} {rule?.result}<span>{rule ? '.' : ''}</span>
                                        </p>
                                        <div className="bottomDivider"></div>

                                        <h6 className="m-1" style={{ fontSize: 18 }}>Reason
                                            <div className="mt-1" style={{ width: 55, borderBottom: '1px solid #0080A8' }}></div></h6>
                                        <p className="mt-2 mx-1" style={{ fontSize: 14 }}>{rule?.Reason}<span>{rule ? '.' : ''}</span></p>
                                        <div className="bottomDivider"></div>
                                    </div>

                                    <h6 className="m-1" style={{ fontSize: 18 }}>Info
                                        <div className="mt-1" style={{ width: 28, borderBottom: '1px solid #0080A8' }}></div></h6>
                                    <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Tags:</strong> {rule?.tags.length > 0 && (rule.tags).join(', ')}</p>
                                    <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created On:</strong> {(new Date(rule?.created_at)).toLocaleDateString()}</p>
                                    <p className="mt-2 mx-1 font-face-futura" style={{ fontSize: 14, lineHeight: '1rem' }}><strong>Created By:</strong> Loren Dilger</p>
                                    <div className="bottomDivider"></div>

                                    <div align="center" className="mrtop-55">
                                        <Button className="text-white ruleBtn" variant="contained" onClick={(id) => this.editLastRule(rule?.ruleId)}>
                                            <span className='font-face-futura'>Edit</span>
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="text-white" style={showStyle} onClick={this.handleShow}>
                                <VisibilityOffIcon className="mt-2" /><br />
                                <span className='font-face-futura' style={{ fontSize: 12 }}>Last Rule</span>
                            </div>
                        )}
                    </Box>
                </div>} */}

                {showChargesPopup &&
                    <div>
                        <Dialog
                            className="claims-modal claims-modal-custom"
                            fullWidth
                            maxWidth="md"
                            open={showChargesPopup}
                            onClose={this.closeChargesPopup}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description">
                            <DialogTitle id="alert-dialog-title" >
                                <p className='chargesTitle font-face-futura'><span className='mx-2'>{"REFRESH ENCOUNTERS"}</span>
                                    <p style={{ borderBottom: '1px solid #7BBC9B' }}></p>
                                </p>
                            </DialogTitle>
                            <DialogContent>
                                <div>
                                    <div className='font-face-futura'>
                                        <label htmlFor='select' className='labelDialog'><b>Select Filter:</b></label>
                                        <select className='mt-1 selectStyles selectDialog'
                                            value={selectDateType}
                                            onChange={this.handleChargesDropdown}>
                                            <option name="createdDate" value="createdDate">Created Date</option>
                                            <option name="serviceDate" value="serviceDate">Service Date</option>
                                        </select>
                                    </div>
                                    <div className='mt-4 font-face-futura'>
                                        <div className='row'>
                                            <div className='col-6 col-sm-6 col-lg-6'>
                                                <label htmlFor='select' className='labelDialog'><b>From:</b></label>
                                                <DatePicker className='date-pick text-dark'
                                                    name='from'
                                                    format={"MM-dd-yyyy"}
                                                    selected={fromDate ? fromDate : myPastDate}
                                                    minDate={maxPastDate}
                                                    onChange={this.handleFromDate}
                                                    preventOpenOnFocus={true}
                                                    customInput={
                                                        <MaskedInput
                                                            pipe={autoCorrectedDatePipe}
                                                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                                                            guide={true}
                                                            keepCharPositions={true} />
                                                    } />
                                            </div>
                                            <div className='col-6 col-sm-6 col-lg-6'>
                                                <label htmlFor='select' className='labelDialog'><b>To:</b></label>
                                                <DatePicker className='date-pick text-dark'
                                                    name='to'
                                                    format={"MM-dd-yyyy"}
                                                    selected={toDate ? toDate : currentToDate}
                                                    minDate={maxPastDate}
                                                    onChange={this.handleToDate}
                                                    preventOpenOnFocus={true}
                                                    customInput={
                                                        <MaskedInput
                                                            pipe={autoCorrectedDatePipe}
                                                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                                                            guide={true}
                                                            keepCharPositions={true} />} />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className='row mt-4'>
                                            <div className='col-6 col-sm-6 col-lg-6'>
                                                <Button fullWidth className='text-white closeBtn' variant='contained' onClick={this.closeChargesPopup}>
                                                    <span className='font-face-futura'>Close</span>
                                                </Button>
                                            </div>
                                            <div className='col-6 col-sm-6 col-lg-6'>
                                                <Button fullWidth className='text-white refreshBtn' variant='contained' onClick={() => this.isDateValid()}>
                                                    <span className='font-face-futura'>Refresh</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </div>
                }

                {showRunningCharges &&
                    <Dialog
                        fullWidth
                        open={showRunningCharges}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className={showCancelRunningCharges ? 'avatar2' : 'avatar'}>
                            <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                            <Loader className="mt-2" type='Oval'
                                height={180}
                                width={195}
                                color="#5CB02C"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#5CB02C"
                                strokeWidth={2}
                                strokeWidthSecondary={2} />
                        </div>
                        <div align="center" className={showCancelRunningCharges ? 'dialog-box2' : 'dialog-box'}>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"Updating Encounters"}</span>
                            </DialogTitle>
                            {showCancelRunningCharges ?
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hold tight while we fetch a new list of claims!</span>
                                    </DialogContentText><br />
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                        <span className='dialogText'>Give us a little bit longer</span>
                                    </DialogContentText>
                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                        <span className='font-face-futura'>Cancel</span>
                                    </Button>
                                </DialogContent> :
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='font-face-futura dialogText'>Let's get you a new list of claims!</span>
                                    </DialogContentText>
                                </DialogContent>}
                        </div>
                    </Dialog>
                }

                {showChargesTryAgain &&
                    <Dialog
                        fullWidth
                        open={showChargesTryAgain}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className='avatar3'>
                            <CancelIcon className='dialogCancel' fontSize='large' />
                        </div>
                        <div align="center" className='dialog-box3'>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"UH, OH!"}</span>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <span className='font-face-futura dialogText'>We aren't able to fetch the claims</span>
                                </DialogContentText>
                                <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                    <span className='font-face-futura'>THAT'S OKAY, I'LL TRY AGAIN</span>
                                </Button>
                            </DialogContent>
                        </div>
                    </Dialog>
                }

                {/* {showPopup &&
                    <><Dialog
                        fullWidth
                        open={showPopup}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className={showCancelPopup ? 'avatar2' : 'avatar'}>
                            <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                            <Loader className="mt-2" type='Oval'
                                height={180}
                                width={195}
                                color="#5CB02C"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#5CB02C"
                                strokeWidth={2}
                                strokeWidthSecondary={2} />
                        </div>
                        <div align="center" className={showCancelPopup ? 'dialog-box2' : 'dialog-box'}>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"Running Encounters"}</span>
                            </DialogTitle>
                            {showCancelPopup ?
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hold tight while we scrub these claims!</span>
                                    </DialogContentText><br />
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                        <span className='dialogText'>Give us a little bit longer</span>
                                    </DialogContentText>
                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                        <span className='font-face-futura'>Cancel</span>
                                    </Button>
                                </DialogContent> :
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='font-face-futura dialogText'>Hold tight while we scrub these claims!</span>
                                    </DialogContentText>
                                </DialogContent>
                            }
                        </div>
                    </Dialog>

                    <div align="center" className='new-avatar'>
                        <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                        <Loader className="mt-2" type='Oval'
                            height={180}
                            width={195}
                            color="#5CB02C"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#5CB02C"
                            strokeWidth={2}
                            strokeWidthSecondary={2} />
                        <span className='font-face-futura dialogTitle'>{"Running Encounters"}</span><br />
                        {showCancelPopup ?
                            <>
                                <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                <span className='dialogText'>Give us a little bit longer</span>
                                <div>
                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                        <span className='font-face-futura'>Cancel</span>
                                    </Button>
                                </div>
                            </> :
                            <span className='font-face-futura dialogText'>Hold tight while we scrub these claims!</span>}
                    </div></>
                } */}

                {/* {showRulesTryAgain &&
                    <Dialog
                        fullWidth
                        open={showRulesTryAgain}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className='avatar3'>
                            <CancelIcon className='dialogCancel' fontSize='large' />
                        </div>
                        <div align="center" className='dialog-box3'>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"UH, OH!"}</span>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <span className='font-face-futura dialogText'>We aren't able to finish scrubbing</span>
                                </DialogContentText>
                                <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                    <span className='font-face-futura'>THAT'S OKAY, I'LL TRY AGAIN</span>
                                </Button>
                            </DialogContent>
                        </div>
                    </Dialog>
                } */}

                {/* {this.state.enableAutoRunRuleSetting &&
                    <div align="center" className='new-avatar'>
                        <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                        <Loader className="mt-2" type='Oval'
                            height={180}
                            width={195}
                            color="#5CB02C"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#5CB02C"
                            strokeWidth={2}
                            strokeWidthSecondary={2} />
                        <span className='font-face-futura dialogTitle'>{"Auto-Run is Processing"}</span><br />
                        <span className='font-face-futura dialogText'>Hold tight while we scrub your claims!</span>
                    </div>
                } */}

                {showLoader &&
                    <Dialog
                        fullWidth
                        open={showLoader}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className={showCancelLoader ? 'avatar2' : 'avatar'}>
                            <img src={ruleoutLogo} alt="ruleout" className='ruleoutLogo' />
                            <Loader className="mt-2" type='Oval'
                                height={180}
                                width={195}
                                color="#5CB02C"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#5CB02C"
                                strokeWidth={2}
                                strokeWidthSecondary={2} />
                        </div>
                        <div align="center" className={showCancelLoader ? 'dialog-box2' : 'dialog-box'}>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"Updating Encounters"}</span>
                            </DialogTitle>
                            {showCancelLoader ?
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hold tight while we fetch the list of encounters!</span>
                                    </DialogContentText><br />
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='dialogText'>Hmm... This is taking longer than expected.</span><br />
                                        <span className='dialogText'>Give us a little bit longer</span>
                                    </DialogContentText>
                                    <Button fullWidth className='mt-4 dialogBtn' variant='contained' onClick={() => window.location.reload()}>
                                        <span className='font-face-futura'>Cancel</span>
                                    </Button>
                                </DialogContent> :
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <span className='font-face-futura dialogText'>Let's get you the list of claims!</span>
                                    </DialogContentText>
                                </DialogContent>}
                        </div>
                    </Dialog>
                }

                {showProviderPopUp &&
                    <Dialog
                        fullWidth
                        open={showProviderPopUp}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <div align="center" className='avatar3'>
                            <CancelIcon className='dialogCancel' fontSize='large' />
                        </div>
                        <div align="center" className='dialog-box4'>
                            <DialogTitle id="alert-dialog-title">
                                <span className='font-face-futura dialogTitle'>{"UH, OH!"}</span>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <span className='font-face-futura dialogText'>You do not have a valid license for one or more providers you are trying to run.</span>
                                </DialogContentText><br />
                                <DialogContentText id="alert-dialog-description">
                                    <span className='font-face-futura dialogText'>Have your system admin add the provider(s) in the settings to run the encounter</span>
                                </DialogContentText>
                                <Button fullWidth className='mt-4 mx-1 provBtn' variant='contained' onClick={() => this.handleProviderPopup()}>
                                    <span className='font-face-futura'>THAT'S OKAY, I'LL TRY AGAIN</span>
                                </Button>
                                <Button fullWidth className='mt-4 mx-1 activeBtn' variant='contained' onClick={() => this.runRules()}>
                                    <span className='font-face-futura'>Run Active Only</span>
                                </Button>
                            </DialogContent>
                        </div>
                    </Dialog>
                }

                <Footer
                    ruleSuccess={this.state.ruleSuccess}
                    formattedRuleDate={this.state.formattedRuleDate}
                    selectValue={this.state.searchKey}
                    onSelectChange={this.handleSelectChange}
                    apiLoading={this.state.apiLoading}
                    columnData={this.state.selectedColumnData}
                    filterValue={this.state.filterKey}
                    searchFilterValues={this.searchFilterValues}
                    checkboxValues={this.state.checkboxValues}
                    handleCheckbox={this.handleCheckboxValues}
                    handleGobackCheckbox={this.handleGoBackCheckbox}
                    showSearch={this.state.showSearch}
                    showCheckedValues={this.state.showCheckedValues}
                    handleGoBack={this.handleGoBack}
                    filteredValues={this.state.filterData}
                    filterTable={this.filterTable}
                    clearFilter={this.clearFilter}
                    optionSelector={this.state.optionSelector}
                    selectHandler={this.selectHandler}
                    handleSelectHandler={() => this.setState({ optionSelector: false })}
                    onClaimChange={this.handleClaimChange}
                    claimSelector={this.state.claimSelector}
                    claimHandler={this.claimHandler}
                    closeClaimsDropdown={this.closeClaimsDropdown} // for closing from outside click
                    labelValue={role?.roleId == 9 ? "Worklist" : this.state.labelValue}
                    // labelValue={this.state.labelValue}
                    // draftPlaceholder={this.state.draftPlaceholder}
                    searchValue={this.state.searchValue}
                    onInputChange={this.handleInputChange}
                    onDateChange={(e) => this.handleDateChange(e, this.state.formattedRuleDate)}
                    isCalendarOpen={this.state.isCalendarOpen}
                    handleCalendarOpen={this.handleCalendarOpen} // Pass down the open handler
                    handleCalendarClose={this.handleCalendarClose} // Pass down the close handler
                    handleClaimsDropdown={this.handleClaimsDropdown}
                    claimsDropdownSelect={this.state.claimsDropdownSelect}
                    assignedTo={this.state.assignTo}
                    whatsNeeded={this.state.whatsNeededCS}
                />
            </section>
        )
    }
}

RuleProcessor.propTypes = {
    history: PropTypes.array.isRequired
}

export default withRouter(RuleProcessor);
